# mongo birdAPI
db.dropDatabase()

data_names = [
    {
        sc:"galliformes"
        ja:"キジ目"
        rank:"order"
    }
    {
        sc:"anseriformes"
        ja:"カモ目"
        rank:"order"
    }
    {
        sc:"podicipediformes"
        ja:"カイツブリ目"
        rank:"order"
    }
    {
        sc:"phaethontiformes"
        ja:"ネッタイチョウ目"
        rank:"order"
    }
    {
        sc:"pterocliformes"
        ja:"サケイ目"
        rank:"order"
    }
    {
        sc:"columbiformes"
        ja:"ハト目"
        rank:"order"
    }
    {
        sc:"gaviiformes"
        ja:"アビ目"
        rank:"order"
    }
    {
        sc:"procellariiformes"
        ja:"ミズナギドリ目"
        rank:"order"
    }
    {
        sc:"ciconiiformes"
        ja:"コウノトリ目"
        rank:"order"
    }
    {
        sc:"suliformes"
        ja:"カツオドリ目"
        rank:"order"
    }
    {
        sc:"pelecaniformes"
        ja:"ペリカン目"
        rank:"order"
    }
    {
        sc:"gruiformes"
        ja:"ツル目"
        rank:"order"
    }
    {
        sc:"otidiformes"
        ja:"ノガン目"
        rank:"order"
    }
    {
        sc:"cuculiformes"
        ja:"カッコウ目"
        rank:"order"
    }
    {
        sc:"caprimulgiformes"
        ja:"ヨタカ目"
        rank:"order"
    }
    {
        sc:"apodiformes"
        ja:"アマツバメ目"
        rank:"order"
    }
    {
        sc:"charadriiformes"
        ja:"チドリ目"
        rank:"order"
    }
    {
        sc:"accipitriformes"
        ja:"タカ目"
        rank:"order"
    }
    {
        sc:"strigiformes"
        ja:"フクロウ目"
        rank:"order"
    }
    {
        sc:"bucerotiformes"
        ja:"サイチョウ目"
        rank:"order"
    }
    {
        sc:"coraciiformes"
        ja:"ブッポウソウ目"
        rank:"order"
    }
    {
        sc:"piciformes"
        ja:"キツツキ目"
        rank:"order"
    }
    {
        sc:"falconiformes"
        ja:"ハヤブサ目"
        rank:"order"
    }
    {
        sc:"passeriformes"
        ja:"スズメ目"
        rank:"order"
    }
    {
        sc:"galliformes"
        ja:"キジ目"
        rank:"order"
    }
    {
        sc:"anseriformes"
        ja:"カモ目"
        rank:"order"
    }
    {
        sc:"columbiformes"
        ja:"ハト目"
        rank:"order"
    }
    {
        sc:"ciconiiformes"
        ja:"コウノトリ目"
        rank:"order"
    }
    {
        sc:"pelecaniformes"
        ja:"ペリカン目"
        rank:"order"
    }
    {
        sc:"charadriiformes"
        ja:"チドリ目"
        rank:"order"
    }
    {
        sc:"psittaciformes"
        ja:"インコ目"
        rank:"order"
    }
    {
        sc:"passeriformes"
        ja:"スズメ目"
        rank:"order"
    }
    {
        sc:"phasianidae"
        ja:"キジ科"
        rank:"family"
        upper:"galliformes"
    }
    {
        sc:"anatidae"
        ja:"カモ科"
        rank:"family"
        upper:"anseriformes"
    }
    {
        sc:"podicipedidae"
        ja:"カイツブリ科"
        rank:"family"
        upper:"podicipediformes"
    }
    {
        sc:"phaethontidae"
        ja:"ネッタイチョウ科"
        rank:"family"
        upper:"phaethontiformes"
    }
    {
        sc:"pteroclidae"
        ja:"サケイ科"
        rank:"family"
        upper:"pterocliformes"
    }
    {
        sc:"columbidae"
        ja:"ハト科"
        rank:"family"
        upper:"columbiformes"
    }
    {
        sc:"gaviidae"
        ja:"アビ科"
        rank:"family"
        upper:"gaviiformes"
    }
    {
        sc:"diomedeidae"
        ja:"アホウドリ科"
        rank:"family"
        upper:"procellariiformes"
    }
    {
        sc:"procellariidae"
        ja:"ミズナギドリ科"
        rank:"family"
        upper:"procellariiformes"
    }
    {
        sc:"hydrobatidae"
        ja:"ウミツバメ科"
        rank:"family"
        upper:"procellariiformes"
    }
    {
        sc:"ciconiidae"
        ja:"コウノトリ科"
        rank:"family"
        upper:"ciconiiformes"
    }
    {
        sc:"fregatidae"
        ja:"グンカンドリ科"
        rank:"family"
        upper:"suliformes"
    }
    {
        sc:"sulidae"
        ja:"カツオドリ科"
        rank:"family"
        upper:"suliformes"
    }
    {
        sc:"phalacrocoracidae"
        ja:"ウ科"
        rank:"family"
        upper:"suliformes"
    }
    {
        sc:"pelecanidae"
        ja:"ペリカン科"
        rank:"family"
        upper:"pelecaniformes"
    }
    {
        sc:"ardeidae"
        ja:"サギ科"
        rank:"family"
        upper:"pelecaniformes"
    }
    {
        sc:"threskiornithidae"
        ja:"トキ科"
        rank:"family"
        upper:"pelecaniformes"
    }
    {
        sc:"gruidae"
        ja:"ツル科"
        rank:"family"
        upper:"gruiformes"
    }
    {
        sc:"rallidae"
        ja:"クイナ科"
        rank:"family"
        upper:"gruiformes"
    }
    {
        sc:"otididae"
        ja:"ノガン科"
        rank:"family"
        upper:"otidiformes"
    }
    {
        sc:"cuculidae"
        ja:"カッコウ科"
        rank:"family"
        upper:"cuculiformes"
    }
    {
        sc:"caprimulgidae"
        ja:"ヨタカ科"
        rank:"family"
        upper:"caprimulgiformes"
    }
    {
        sc:"apodidae"
        ja:"アマツバメ科"
        rank:"family"
        upper:"apodiformes"
    }
    {
        sc:"charadriidae"
        ja:"チドリ科"
        rank:"family"
        upper:"charadriiformes"
    }
    {
        sc:"haematopodidae"
        ja:"ミヤコドリ科"
        rank:"family"
        upper:"charadriiformes"
    }
    {
        sc:"recurvirostridae"
        ja:"セイタカシギ科"
        rank:"family"
        upper:"charadriiformes"
    }
    {
        sc:"scolopacidae"
        ja:"シギ科"
        rank:"family"
        upper:"charadriiformes"
    }
    {
        sc:"jacanidae"
        ja:"レンカク科"
        rank:"family"
        upper:"charadriiformes"
    }
    {
        sc:"rostratulidae"
        ja:"タマシギ科"
        rank:"family"
        upper:"charadriiformes"
    }
    {
        sc:"turnicidae"
        ja:"ミフウズラ科"
        rank:"family"
        upper:"charadriiformes"
    }
    {
        sc:"glareolidae"
        ja:"ツバメチドリ科"
        rank:"family"
        upper:"charadriiformes"
    }
    {
        sc:"laridae"
        ja:"カモメ科"
        rank:"family"
        upper:"charadriiformes"
    }
    {
        sc:"stercorariidae"
        ja:"トウゾクカモメ科"
        rank:"family"
        upper:"charadriiformes"
    }
    {
        sc:"alcidae"
        ja:"ウミスズメ科"
        rank:"family"
        upper:"charadriiformes"
    }
    {
        sc:"pandionidae"
        ja:"ミサゴ科"
        rank:"family"
        upper:"accipitriformes"
    }
    {
        sc:"accipitridae"
        ja:"タカ科"
        rank:"family"
        upper:"accipitriformes"
    }
    {
        sc:"tytonidae"
        ja:"メンフクロウ科"
        rank:"family"
        upper:"strigiformes"
    }
    {
        sc:"strigidae"
        ja:"フクロウ科"
        rank:"family"
        upper:"strigiformes"
    }
    {
        sc:"upupidae"
        ja:"ヤツガシラ科"
        rank:"family"
        upper:"bucerotiformes"
    }
    {
        sc:"alcedinidae"
        ja:"カワセミ科"
        rank:"family"
        upper:"coraciiformes"
    }
    {
        sc:"meropidae"
        ja:"ハチクイ科"
        rank:"family"
        upper:"coraciiformes"
    }
    {
        sc:"coraciidae"
        ja:"ブッポウソウ科"
        rank:"family"
        upper:"coraciiformes"
    }
    {
        sc:"picidae"
        ja:"キツツキ科"
        rank:"family"
        upper:"piciformes"
    }
    {
        sc:"falconidae"
        ja:"ハヤブサ科"
        rank:"family"
        upper:"falconiformes"
    }
    {
        sc:"pittidae"
        ja:"ヤイロチョウ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"artamidae"
        ja:"モリツバメ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"campephagidae"
        ja:"サンショウクイ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"oriolidae"
        ja:"コウライウグイス科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"dicruridae"
        ja:"オウチュウ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"monarchidae"
        ja:"カササギヒタキ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"laniidae"
        ja:"モズ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"corvidae"
        ja:"カラス科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"regulidae"
        ja:"キクイタダキ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"remizidae"
        ja:"ツリスガラ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"paridae"
        ja:"シジュウカラ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"panuridae"
        ja:"ヒゲガラ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"alaudidae"
        ja:"ヒバリ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"hirundinidae"
        ja:"ツバメ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"pycnonotidae"
        ja:"ヒヨドリ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"cettiidae"
        ja:"ウグイス科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"aegithalidae"
        ja:"エナガ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"phylloscopidae"
        ja:"ムシクイ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"sylviidae"
        ja:"ズグロムシクイ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"zosteropidae"
        ja:"メジロ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"locustellidae"
        ja:"センニュウ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"acrocephalidae"
        ja:"ヨシキリ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"cisticolidae"
        ja:"セッカ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"bombycillidae"
        ja:"レンジャク科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"sittidae"
        ja:"ゴジュウカラ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"certhiidae"
        ja:"キバシリ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"troglodytidae"
        ja:"ミソサザイ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"sturnidae"
        ja:"ムクドリ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"cinclidae"
        ja:"カワガラス科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"muscicapidae"
        ja:"ヒタキ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"prunellidae"
        ja:"イワヒバリ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"passeridae"
        ja:"スズメ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"motacillidae"
        ja:"セキレイ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"fringillidae"
        ja:"アトリ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"calcariidae"
        ja:"ツメナガホオジロ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"parulidae"
        ja:"アメリカムシクイ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"emberizidae"
        ja:"ホオジロ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"psittacidae"
        ja:"インコ科"
        rank:"family"
        upper:"psittaciformes"
    }
    {
        sc:"timaliidae"
        ja:"チメドリ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"ploceidae"
        ja:"ハタオリドリ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"estrildidae"
        ja:"カエデチョウ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"viduidae"
        ja:"テンニンチョウ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"thraupidae"
        ja:"フウキンチョウ科"
        rank:"family"
        upper:"passeriformes"
    }
    {
        sc:"tetrastes"
        ja:"エゾライチョウ属"
        rank:"genus"
        upper:"phasianidae"

    }
    {
        sc:"lagopus"
        ja:"ライチョウ属"
        rank:"genus"
        upper:"phasianidae"

    }
    {
        sc:"coturnix"
        ja:"ウズラ属"
        rank:"genus"
        upper:"phasianidae"

    }
    {
        sc:"syrmaticus"
        ja:"ヤマドリ属"
        rank:"genus"
        upper:"phasianidae"

    }
    {
        sc:"phasianus"
        ja:"キジ属"
        rank:"genus"
        upper:"phasianidae"

    }
    {
        sc:"dendrocygna"
        ja:"リュウキュウガモ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"anser"
        ja:"マガン属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"branta"
        ja:"コクガン属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"cygnus"
        ja:"ハクチョウ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"tadorna"
        ja:"ツクシガモ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"aix"
        ja:"オシドリ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"nettapus"
        ja:"ナンキンオシ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"anas"
        ja:"マガモ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"netta"
        ja:"アカハシハジロ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"aythya"
        ja:"スズガモ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"polysticta"
        ja:"コケワタガモ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"somateria"
        ja:"ケワタガモ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"histrionicus"
        ja:"シノリガモ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"melanitta"
        ja:"ビロードキンクロ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"clangula"
        ja:"コオリガモ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"bucephala"
        ja:"ホオジロガモ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"mergellus"
        ja:"ミコアイサ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"mergus"
        ja:"ウミアイサ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"tachybaptus"
        ja:"カイツブリ属"
        rank:"genus"
        upper:"podicipedidae"

    }
    {
        sc:"podiceps"
        ja:"カンムリカイツブリ属"
        rank:"genus"
        upper:"podicipedidae"

    }
    {
        sc:"phaethon"
        ja:"ネッタイチョウ属"
        rank:"genus"
        upper:"phaethontidae"

    }
    {
        sc:"syrrhaptes"
        ja:"サケイ属"
        rank:"genus"
        upper:"pteroclidae"

    }
    {
        sc:"columba"
        ja:"カワラバト属"
        rank:"genus"
        upper:"columbidae"

    }
    {
        sc:"streptopelia"
        ja:"キジバト属"
        rank:"genus"
        upper:"columbidae"

    }
    {
        sc:"chalcophaps"
        ja:"キンバト属"
        rank:"genus"
        upper:"columbidae"

    }
    {
        sc:"treron"
        ja:"アオバト属"
        rank:"genus"
        upper:"columbidae"

    }
    {
        sc:"ptilinopus"
        ja:"ヒメアオバト属"
        rank:"genus"
        upper:"columbidae"

    }
    {
        sc:"gavia"
        ja:"アビ属"
        rank:"genus"
        upper:"gaviidae"

    }
    {
        sc:"phoebastria"
        ja:"アホウドリ属"
        rank:"genus"
        upper:"diomedeidae"

    }
    {
        sc:"fulmarus"
        ja:"フルマカモメ属"
        rank:"genus"
        upper:"procellariidae"

    }
    {
        sc:"pterodroma"
        ja:"シロハラミズナギドリ属"
        rank:"genus"
        upper:"procellariidae"

    }
    {
        sc:"calonectris"
        ja:"オオミズナギドリ属"
        rank:"genus"
        upper:"procellariidae"

    }
    {
        sc:"puffinus"
        ja:"ハイイロミズナギドリ属"
        rank:"genus"
        upper:"procellariidae"

    }
    {
        sc:"bulweria"
        ja:"アナドリ属"
        rank:"genus"
        upper:"procellariidae"

    }
    {
        sc:"oceanites"
        ja:"アシナガウミツバメ属"
        rank:"genus"
        upper:"hydrobatidae"

    }
    {
        sc:"oceanodroma"
        ja:"オーストンウミツバメ属"
        rank:"genus"
        upper:"hydrobatidae"

    }
    {
        sc:"ciconia"
        ja:"コウノトリ属"
        rank:"genus"
        upper:"ciconiidae"

    }
    {
        sc:"fregata"
        ja:"グンカンドリ属"
        rank:"genus"
        upper:"fregatidae"

    }
    {
        sc:"sula"
        ja:"カツオドリ属"
        rank:"genus"
        upper:"sulidae"

    }
    {
        sc:"phalacrocorax"
        ja:"ウ属"
        rank:"genus"
        upper:"phalacrocoracidae"

    }
    {
        sc:"pelecanus"
        ja:"ペリカン属"
        rank:"genus"
        upper:"pelecanidae"

    }
    {
        sc:"botaurus"
        ja:"サンカノゴイ属"
        rank:"genus"
        upper:"ardeidae"

    }
    {
        sc:"ixobrychus"
        ja:"ヨシゴイ属"
        rank:"genus"
        upper:"ardeidae"

    }
    {
        sc:"gorsachius"
        ja:"ミゾゴイ属"
        rank:"genus"
        upper:"ardeidae"

    }
    {
        sc:"nycticorax"
        ja:"ゴイサギ属"
        rank:"genus"
        upper:"ardeidae"

    }
    {
        sc:"butorides"
        ja:"ササゴイ属"
        rank:"genus"
        upper:"ardeidae"

    }
    {
        sc:"ardeola"
        ja:"アカガシラサギ属"
        rank:"genus"
        upper:"ardeidae"

    }
    {
        sc:"bubulcus"
        ja:"アマサギ属"
        rank:"genus"
        upper:"ardeidae"

    }
    {
        sc:"ardea"
        ja:"アオサギ属"
        rank:"genus"
        upper:"ardeidae"

    }
    {
        sc:"egretta"
        ja:"コサギ属"
        rank:"genus"
        upper:"ardeidae"

    }
    {
        sc:"threskiornis"
        ja:"クロトキ属"
        rank:"genus"
        upper:"threskiornithidae"

    }
    {
        sc:"nipponia"
        ja:"トキ属"
        rank:"genus"
        upper:"threskiornithidae"

    }
    {
        sc:"platalea"
        ja:"ヘラサギ属"
        rank:"genus"
        upper:"threskiornithidae"

    }
    {
        sc:"grus"
        ja:"ツル属"
        rank:"genus"
        upper:"gruidae"

    }
    {
        sc:"anthropoides"
        ja:"アネハヅル属"
        rank:"genus"
        upper:"gruidae"

    }
    {
        sc:"coturnicops"
        ja:"シマクイナ属"
        rank:"genus"
        upper:"rallidae"

    }
    {
        sc:"rallina"
        ja:"オオクイナ属"
        rank:"genus"
        upper:"rallidae"

    }
    {
        sc:"gallirallus"
        ja:"ヤンバルクイナ属"
        rank:"genus"
        upper:"rallidae"

    }
    {
        sc:"rallus"
        ja:"クイナ属"
        rank:"genus"
        upper:"rallidae"

    }
    {
        sc:"amaurornis"
        ja:"シロハラクイナ属"
        rank:"genus"
        upper:"rallidae"

    }
    {
        sc:"porzana"
        ja:"ヒメクイナ属"
        rank:"genus"
        upper:"rallidae"

    }
    {
        sc:"gallicrex"
        ja:"ツルクイナ属"
        rank:"genus"
        upper:"rallidae"

    }
    {
        sc:"gallinula"
        ja:"バン属"
        rank:"genus"
        upper:"rallidae"

    }
    {
        sc:"fulica"
        ja:"オオバン属"
        rank:"genus"
        upper:"rallidae"

    }
    {
        sc:"otis"
        ja:"ノガン属"
        rank:"genus"
        upper:"otididae"

    }
    {
        sc:"tetrax"
        ja:"ヒメノガン属"
        rank:"genus"
        upper:"otididae"

    }
    {
        sc:"centropus"
        ja:"バンケン属"
        rank:"genus"
        upper:"cuculidae"

    }
    {
        sc:"clamator"
        ja:"カンムリカッコウ属"
        rank:"genus"
        upper:"cuculidae"

    }
    {
        sc:"eudynamys"
        ja:"オニカッコウ属"
        rank:"genus"
        upper:"cuculidae"

    }
    {
        sc:"urodynamis"
        ja:"キジカッコウ属"
        rank:"genus"
        upper:"cuculidae"

    }
    {
        sc:"surniculus"
        ja:"オウチュウカッコウ属"
        rank:"genus"
        upper:"cuculidae"

    }
    {
        sc:"hierococcyx"
        ja:"ジュウイチ属"
        rank:"genus"
        upper:"cuculidae"

    }
    {
        sc:"cuculus"
        ja:"カッコウ属"
        rank:"genus"
        upper:"cuculidae"

    }
    {
        sc:"caprimulgus"
        ja:"ヨタカ属"
        rank:"genus"
        upper:"caprimulgidae"

    }
    {
        sc:"aerodramus"
        ja:"ヒマラヤアナツバメ属"
        rank:"genus"
        upper:"apodidae"

    }
    {
        sc:"hirundapus"
        ja:"ハリオアマツバメ属"
        rank:"genus"
        upper:"apodidae"

    }
    {
        sc:"apus"
        ja:"アマツバメ属"
        rank:"genus"
        upper:"apodidae"

    }
    {
        sc:"vanellus"
        ja:"タゲリ属"
        rank:"genus"
        upper:"charadriidae"

    }
    {
        sc:"pluvialis"
        ja:"ムナグロ属"
        rank:"genus"
        upper:"charadriidae"

    }
    {
        sc:"charadrius"
        ja:"チドリ属"
        rank:"genus"
        upper:"charadriidae"

    }
    {
        sc:"haematopus"
        ja:"ミヤコドリ属"
        rank:"genus"
        upper:"haematopodidae"

    }
    {
        sc:"himantopus"
        ja:"セイタカシギ属"
        rank:"genus"
        upper:"recurvirostridae"

    }
    {
        sc:"recurvirostra"
        ja:"ソリハシセイタカシギ属"
        rank:"genus"
        upper:"recurvirostridae"

    }
    {
        sc:"scolopax"
        ja:"ヤマシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"lymnocryptes"
        ja:"コシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"gallinago"
        ja:"タシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"limnodromus"
        ja:"オオハシシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"limosa"
        ja:"オグロシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"numenius"
        ja:"ダイシャクシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"tringa"
        ja:"クサシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"heteroscelus"
        ja:"キアシシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"xenus"
        ja:"ソリハシシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"actitis"
        ja:"イソシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"arenaria"
        ja:"キョウジョシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"calidris"
        ja:"オバシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"eurynorhynchus"
        ja:"ヘラシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"limicola"
        ja:"キリアイ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"tryngites"
        ja:"コモンシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"philomachus"
        ja:"エリマキシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"phalaropus"
        ja:"ヒレアシシギ属"
        rank:"genus"
        upper:"scolopacidae"

    }
    {
        sc:"hydrophasianus"
        ja:"レンカク属"
        rank:"genus"
        upper:"jacanidae"

    }
    {
        sc:"rostratula"
        ja:"タマシギ属"
        rank:"genus"
        upper:"rostratulidae"

    }
    {
        sc:"turnix"
        ja:"ミフウズラ属"
        rank:"genus"
        upper:"turnicidae"

    }
    {
        sc:"glareola"
        ja:"ツバメチドリ属"
        rank:"genus"
        upper:"glareolidae"

    }
    {
        sc:"anous"
        ja:"クロアジサシ属"
        rank:"genus"
        upper:"laridae"

    }
    {
        sc:"procelsterna"
        ja:"ハイイロアジサシ属"
        rank:"genus"
        upper:"laridae"

    }
    {
        sc:"gygis"
        ja:"シロアジサシ属"
        rank:"genus"
        upper:"laridae"

    }
    {
        sc:"rissa"
        ja:"ミツユビカモメ属"
        rank:"genus"
        upper:"laridae"

    }
    {
        sc:"pagophila"
        ja:"ゾウゲカモメ属"
        rank:"genus"
        upper:"laridae"

    }
    {
        sc:"xema"
        ja:"クビワカモメ属"
        rank:"genus"
        upper:"laridae"

    }
    {
        sc:"rhodostethia"
        ja:"ヒメクビワカモメ属"
        rank:"genus"
        upper:"laridae"

    }
    {
        sc:"larus"
        ja:"カモメ属"
        rank:"genus"
        upper:"laridae"

    }
    {
        sc:"gelochelidon"
        ja:"ハシブトアジサシ属"
        rank:"genus"
        upper:"laridae"

    }
    {
        sc:"sterna"
        ja:"アジサシ属"
        rank:"genus"
        upper:"laridae"

    }
    {
        sc:"chlidonias"
        ja:"クロハラアジサシ属"
        rank:"genus"
        upper:"laridae"

    }
    {
        sc:"stercorarius"
        ja:"トウゾクカモメ属"
        rank:"genus"
        upper:"stercorariidae"

    }
    {
        sc:"alle"
        ja:"ヒメウミスズメ属"
        rank:"genus"
        upper:"alcidae"

    }
    {
        sc:"uria"
        ja:"ウミガラス属"
        rank:"genus"
        upper:"alcidae"

    }
    {
        sc:"alca"
        ja:"オオハシウミガラス属"
        rank:"genus"
        upper:"alcidae"

    }
    {
        sc:"cepphus"
        ja:"ウミバト属"
        rank:"genus"
        upper:"alcidae"

    }
    {
        sc:"brachyramphus"
        ja:"マダラウミスズメ属"
        rank:"genus"
        upper:"alcidae"

    }
    {
        sc:"synthliboramphus"
        ja:"ウミスズメ属"
        rank:"genus"
        upper:"alcidae"

    }
    {
        sc:"aethia"
        ja:"エトロフウミスズメ属"
        rank:"genus"
        upper:"alcidae"

    }
    {
        sc:"cerorhinca"
        ja:"ウトウ属"
        rank:"genus"
        upper:"alcidae"

    }
    {
        sc:"fratercula"
        ja:"ツノメドリ属"
        rank:"genus"
        upper:"alcidae"

    }
    {
        sc:"pandion"
        ja:"ミサゴ属"
        rank:"genus"
        upper:"pandionidae"

    }
    {
        sc:"pernis"
        ja:"ハチクマ属"
        rank:"genus"
        upper:"accipitridae"

    }
    {
        sc:"elanus"
        ja:"カタグロトビ属"
        rank:"genus"
        upper:"accipitridae"

    }
    {
        sc:"milvus"
        ja:"トビ属"
        rank:"genus"
        upper:"accipitridae"

    }
    {
        sc:"haliaeetus"
        ja:"オジロワシ属"
        rank:"genus"
        upper:"accipitridae"

    }
    {
        sc:"aegypius"
        ja:"クロハゲワシ属"
        rank:"genus"
        upper:"accipitridae"

    }
    {
        sc:"spilornis"
        ja:"カンムリワシ属"
        rank:"genus"
        upper:"accipitridae"

    }
    {
        sc:"circus"
        ja:"チュウヒ属"
        rank:"genus"
        upper:"accipitridae"

    }
    {
        sc:"accipiter"
        ja:"ハイタカ属"
        rank:"genus"
        upper:"accipitridae"

    }
    {
        sc:"butastur"
        ja:"サシバ属"
        rank:"genus"
        upper:"accipitridae"

    }
    {
        sc:"buteo"
        ja:"ノスリ属"
        rank:"genus"
        upper:"accipitridae"

    }
    {
        sc:"aquila"
        ja:"イヌワシ属"
        rank:"genus"
        upper:"accipitridae"

    }
    {
        sc:"nisaetus"
        ja:"クマタカ属"
        rank:"genus"
        upper:"accipitridae"

    }
    {
        sc:"tyto"
        ja:"メンフクロウ属"
        rank:"genus"
        upper:"tytonidae"

    }
    {
        sc:"otus"
        ja:"コノハズク属"
        rank:"genus"
        upper:"strigidae"

    }
    {
        sc:"bubo"
        ja:"ワシミミズク属"
        rank:"genus"
        upper:"strigidae"

    }
    {
        sc:"ketupa"
        ja:"シマフクロウ属"
        rank:"genus"
        upper:"strigidae"

    }
    {
        sc:"strix"
        ja:"フクロウ属"
        rank:"genus"
        upper:"strigidae"

    }
    {
        sc:"aegolius"
        ja:"キンメフクロウ属"
        rank:"genus"
        upper:"strigidae"

    }
    {
        sc:"ninox"
        ja:"アオバズク属"
        rank:"genus"
        upper:"strigidae"

    }
    {
        sc:"asio"
        ja:"トラフズク属"
        rank:"genus"
        upper:"strigidae"

    }
    {
        sc:"upupa"
        ja:"ヤツガシラ属"
        rank:"genus"
        upper:"upupidae"

    }
    {
        sc:"halcyon"
        ja:"アカショウビン属"
        rank:"genus"
        upper:"alcedinidae"

    }
    {
        sc:"todiramphus"
        ja:"ナンヨウショウビン属"
        rank:"genus"
        upper:"alcedinidae"

    }
    {
        sc:"alcedo"
        ja:"カワセミ属"
        rank:"genus"
        upper:"alcedinidae"

    }
    {
        sc:"ceyx"
        ja:"ミツユビカワセミ属"
        rank:"genus"
        upper:"alcedinidae"

    }
    {
        sc:"megaceryle"
        ja:"ヤマセミ属"
        rank:"genus"
        upper:"alcedinidae"

    }
    {
        sc:"merops"
        ja:"ハチクイ属"
        rank:"genus"
        upper:"meropidae"

    }
    {
        sc:"eurystomus"
        ja:"ブッポウソウ属"
        rank:"genus"
        upper:"coraciidae"

    }
    {
        sc:"jynx"
        ja:"アリスイ属"
        rank:"genus"
        upper:"picidae"

    }
    {
        sc:"dendrocopos"
        ja:"アカゲラ属"
        rank:"genus"
        upper:"picidae"

    }
    {
        sc:"picoides"
        ja:"ミユビゲラ属"
        rank:"genus"
        upper:"picidae"

    }
    {
        sc:"dryocopus"
        ja:"クマゲラ属"
        rank:"genus"
        upper:"picidae"

    }
    {
        sc:"picus"
        ja:"アオゲラ属"
        rank:"genus"
        upper:"picidae"

    }
    {
        sc:"sapheopipo"
        ja:"ノグチゲラ属"
        rank:"genus"
        upper:"picidae"

    }
    {
        sc:"falco"
        ja:"ハヤブサ属"
        rank:"genus"
        upper:"falconidae"

    }
    {
        sc:"pitta"
        ja:"ヤイロチョウ属"
        rank:"genus"
        upper:"pittidae"

    }
    {
        sc:"artamus"
        ja:"モリツバメ属"
        rank:"genus"
        upper:"artamidae"

    }
    {
        sc:"coracina"
        ja:"アサクラサンショウクイ属"
        rank:"genus"
        upper:"campephagidae"

    }
    {
        sc:"pericrocotus"
        ja:"サンショウクイ属"
        rank:"genus"
        upper:"campephagidae"

    }
    {
        sc:"oriolus"
        ja:"コウライウグイス属"
        rank:"genus"
        upper:"oriolidae"

    }
    {
        sc:"dicrurus"
        ja:"オウチュウ属"
        rank:"genus"
        upper:"dicruridae"

    }
    {
        sc:"hypothymis"
        ja:"クロエリヒタキ属"
        rank:"genus"
        upper:"monarchidae"

    }
    {
        sc:"terpsiphone"
        ja:"サンコウチョウ属"
        rank:"genus"
        upper:"monarchidae"

    }
    {
        sc:"lanius"
        ja:"モズ属"
        rank:"genus"
        upper:"laniidae"

    }
    {
        sc:"garrulus"
        ja:"カケス属"
        rank:"genus"
        upper:"corvidae"

    }
    {
        sc:"cyanopica"
        ja:"オナガ属"
        rank:"genus"
        upper:"corvidae"

    }
    {
        sc:"pica"
        ja:"カササギ属"
        rank:"genus"
        upper:"corvidae"

    }
    {
        sc:"nucifraga"
        ja:"ホシガラス属"
        rank:"genus"
        upper:"corvidae"

    }
    {
        sc:"corvus"
        ja:"カラス属"
        rank:"genus"
        upper:"corvidae"

    }
    {
        sc:"regulus"
        ja:"キクイタダキ属"
        rank:"genus"
        upper:"regulidae"

    }
    {
        sc:"remiz"
        ja:"ツリスガラ属"
        rank:"genus"
        upper:"remizidae"

    }
    {
        sc:"poecile"
        ja:"コガラ属"
        rank:"genus"
        upper:"paridae"

    }
    {
        sc:"periparus"
        ja:"ヒガラ属"
        rank:"genus"
        upper:"paridae"

    }
    {
        sc:"parus"
        ja:"シジュウカラ属"
        rank:"genus"
        upper:"paridae"

    }
    {
        sc:"cyanistes"
        ja:"ルリガラ属"
        rank:"genus"
        upper:"paridae"

    }
    {
        sc:"panurus"
        ja:"ヒゲガラ属"
        rank:"genus"
        upper:"panuridae"

    }
    {
        sc:"melanocorypha"
        ja:"コウテンシ属"
        rank:"genus"
        upper:"alaudidae"

    }
    {
        sc:"calandrella"
        ja:"ヒメコウテンシ属"
        rank:"genus"
        upper:"alaudidae"

    }
    {
        sc:"alauda"
        ja:"ヒバリ属"
        rank:"genus"
        upper:"alaudidae"

    }
    {
        sc:"eremophila"
        ja:"ハマヒバリ属"
        rank:"genus"
        upper:"alaudidae"

    }
    {
        sc:"riparia"
        ja:"ショウドウツバメ属"
        rank:"genus"
        upper:"hirundinidae"

    }
    {
        sc:"tachycineta"
        ja:"ミドリツバメ属"
        rank:"genus"
        upper:"hirundinidae"

    }
    {
        sc:"hirundo"
        ja:"ツバメ属"
        rank:"genus"
        upper:"hirundinidae"

    }
    {
        sc:"delichon"
        ja:"イワツバメ属"
        rank:"genus"
        upper:"hirundinidae"

    }
    {
        sc:"pycnonotus"
        ja:"シロガシラ属"
        rank:"genus"
        upper:"pycnonotidae"

    }
    {
        sc:"hypsipetes"
        ja:"ヒヨドリ属"
        rank:"genus"
        upper:"pycnonotidae"

    }
    {
        sc:"cettia"
        ja:"ウグイス属"
        rank:"genus"
        upper:"cettiidae"

    }
    {
        sc:"urosphena"
        ja:"ヤブサメ属"
        rank:"genus"
        upper:"cettiidae"

    }
    {
        sc:"aegithalos"
        ja:"エナガ属"
        rank:"genus"
        upper:"aegithalidae"

    }
    {
        sc:"phylloscopus"
        ja:"ムシクイ属"
        rank:"genus"
        upper:"phylloscopidae"

    }
    {
        sc:"sylvia"
        ja:"ズグロムシクイ属"
        rank:"genus"
        upper:"sylviidae"

    }
    {
        sc:"apalopteron"
        ja:"メグロ属"
        rank:"genus"
        upper:"zosteropidae"

    }
    {
        sc:"zosterops"
        ja:"メジロ属"
        rank:"genus"
        upper:"zosteropidae"

    }
    {
        sc:"locustella"
        ja:"センニュウ属"
        rank:"genus"
        upper:"locustellidae"

    }
    {
        sc:"acrocephalus"
        ja:"ヨシキリ属"
        rank:"genus"
        upper:"acrocephalidae"

    }
    {
        sc:"iduna"
        ja:"ヒメウタイムシクイ属"
        rank:"genus"
        upper:"acrocephalidae"

    }
    {
        sc:"cisticola"
        ja:"セッカ属"
        rank:"genus"
        upper:"cisticolidae"

    }
    {
        sc:"bombycilla"
        ja:"レンジャク属"
        rank:"genus"
        upper:"bombycillidae"

    }
    {
        sc:"sitta"
        ja:"ゴジュウカラ属"
        rank:"genus"
        upper:"sittidae"

    }
    {
        sc:"certhia"
        ja:"キバシリ属"
        rank:"genus"
        upper:"certhiidae"

    }
    {
        sc:"troglodytes"
        ja:"ミソサザイ属"
        rank:"genus"
        upper:"troglodytidae"

    }
    {
        sc:"spodiopsar"
        ja:"ムクドリ属"
        rank:"genus"
        upper:"sturnidae"

    }
    {
        sc:"agropsar"
        ja:"コムクドリ属"
        rank:"genus"
        upper:"sturnidae"

    }
    {
        sc:"sturnia"
        ja:"カラムクドリ属"
        rank:"genus"
        upper:"sturnidae"

    }
    {
        sc:"pastor"
        ja:"バライロムクドリ属"
        rank:"genus"
        upper:"sturnidae"

    }
    {
        sc:"sturnus"
        ja:"ホシムクドリ属"
        rank:"genus"
        upper:"sturnidae"

    }
    {
        sc:"cinclus"
        ja:"カワガラス属"
        rank:"genus"
        upper:"cinclidae"

    }
    {
        sc:"zoothera"
        ja:"トラツグミ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"cichlopasser"
        ja:"オガサワラガビチョウ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"catharus"
        ja:"チャツグミ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"turdus"
        ja:"ツグミ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"erithacus"
        ja:"ヨーロッパコマドリ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"luscinia"
        ja:"ノゴマ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"tarsiger"
        ja:"ルリビタキ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"phoenicurus"
        ja:"ジョウビタキ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"saxicola"
        ja:"ノビタキ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"oenanthe"
        ja:"サバクヒタキ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"monticola"
        ja:"イソヒヨドリ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"muscicapa"
        ja:"サメビタキ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"ficedula"
        ja:"キビタキ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"cyanoptila"
        ja:"オオルリ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"eumyias"
        ja:"アイイロヒタキ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"niltava"
        ja:"アオヒタキ属"
        rank:"genus"
        upper:"muscicapidae"

    }
    {
        sc:"prunella"
        ja:"カヤクグリ属"
        rank:"genus"
        upper:"prunellidae"

    }
    {
        sc:"passer"
        ja:"スズメ属"
        rank:"genus"
        upper:"passeridae"

    }
    {
        sc:"dendronanthus"
        ja:"イワミセキレイ属"
        rank:"genus"
        upper:"motacillidae"

    }
    {
        sc:"motacilla"
        ja:"セキレイ属"
        rank:"genus"
        upper:"motacillidae"

    }
    {
        sc:"anthus"
        ja:"タヒバリ属"
        rank:"genus"
        upper:"motacillidae"

    }
    {
        sc:"fringilla"
        ja:"アトリ属"
        rank:"genus"
        upper:"fringillidae"

    }
    {
        sc:"chloris"
        ja:"カワラヒワ属"
        rank:"genus"
        upper:"fringillidae"

    }
    {
        sc:"carduelis"
        ja:"マヒワ属"
        rank:"genus"
        upper:"fringillidae"

    }
    {
        sc:"leucosticte"
        ja:"ハギマシコ属"
        rank:"genus"
        upper:"fringillidae"

    }
    {
        sc:"uragus"
        ja:"ベニマシコ属"
        rank:"genus"
        upper:"fringillidae"

    }
    {
        sc:"chaunoproctus"
        ja:"オガサワラマシコ属"
        rank:"genus"
        upper:"fringillidae"

    }
    {
        sc:"carpodacus"
        ja:"オオマシコ属"
        rank:"genus"
        upper:"fringillidae"

    }
    {
        sc:"pinicola"
        ja:"ギンザンマシコ属"
        rank:"genus"
        upper:"fringillidae"

    }
    {
        sc:"loxia"
        ja:"イスカ属"
        rank:"genus"
        upper:"fringillidae"

    }
    {
        sc:"pyrrhula"
        ja:"ウソ属"
        rank:"genus"
        upper:"fringillidae"

    }
    {
        sc:"coccothraustes"
        ja:"シメ属"
        rank:"genus"
        upper:"fringillidae"

    }
    {
        sc:"eophona"
        ja:"イカル属"
        rank:"genus"
        upper:"fringillidae"

    }
    {
        sc:"calcarius"
        ja:"ツメナガホオジロ属"
        rank:"genus"
        upper:"calcariidae"

    }
    {
        sc:"plectrophenax"
        ja:"ユキホオジロ属"
        rank:"genus"
        upper:"calcariidae"

    }
    {
        sc:"setophaga"
        ja:"ハゴロモムシクイ属"
        rank:"genus"
        upper:"parulidae"

    }
    {
        sc:"cardellina"
        ja:"アカガオアメリカムシクイ属"
        rank:"genus"
        upper:"parulidae"

    }
    {
        sc:"emberiza"
        ja:"ホオジロ属"
        rank:"genus"
        upper:"emberizidae"

    }
    {
        sc:"passerella"
        ja:"ゴマフスズメ属"
        rank:"genus"
        upper:"emberizidae"

    }
    {
        sc:"melospiza"
        ja:"ウタスズメ属"
        rank:"genus"
        upper:"emberizidae"

    }
    {
        sc:"zonotrichia"
        ja:"ミヤマシトド属"
        rank:"genus"
        upper:"emberizidae"

    }
    {
        sc:"passerculus"
        ja:"サバンナシトド属"
        rank:"genus"
        upper:"emberizidae"

    }
    {
        sc:"bambusicola"
        ja:"コジュケイ属"
        rank:"genus"
        upper:"phasianidae"

    }
    {
        sc:"syrmaticus"
        ja:"ヤマドリ属"
        rank:"genus"
        upper:"phasianidae"

    }
    {
        sc:"phasianus"
        ja:"キジ属"
        rank:"genus"
        upper:"phasianidae"

    }
    {
        sc:"pavo"
        ja:"クジャク属"
        rank:"genus"
        upper:"phasianidae"

    }
    {
        sc:"branta"
        ja:"コクガン属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"cygnus"
        ja:"ハクチョウ属"
        rank:"genus"
        upper:"anatidae"

    }
    {
        sc:"columba"
        ja:"カワラバト属"
        rank:"genus"
        upper:"columbidae"

    }
    {
        sc:"streptopelia"
        ja:"キジバト属"
        rank:"genus"
        upper:"columbidae"

    }
    {
        sc:"ciconia"
        ja:"コウノトリ属"
        rank:"genus"
        upper:"ciconiidae"

    }
    {
        sc:"nipponia"
        ja:"トキ属"
        rank:"genus"
        upper:"threskiornithidae"

    }
    {
        sc:"himantopus"
        ja:"セイタカシギ属"
        rank:"genus"
        upper:"recurvirostridae"

    }
    {
        sc:"melopsittacus"
        ja:"セキセイインコ属"
        rank:"genus"
        upper:"psittacidae"

    }
    {
        sc:"psittacula"
        ja:"ダルマインコ属"
        rank:"genus"
        upper:"psittacidae"

    }
    {
        sc:"myiopsitta"
        ja:"オキナインコ属"
        rank:"genus"
        upper:"psittacidae"

    }
    {
        sc:"urocissa"
        ja:"サンジャク属"
        rank:"genus"
        upper:"corvidae"

    }
    {
        sc:"pica"
        ja:"カササギ属"
        rank:"genus"
        upper:"corvidae"

    }
    {
        sc:"zosterops"
        ja:"メジロ属"
        rank:"genus"
        upper:"zosteropidae"

    }
    {
        sc:"garrulax"
        ja:"ガビチョウ属"
        rank:"genus"
        upper:"timaliidae"

    }
    {
        sc:"leiothrix"
        ja:"ソウシチョウ属"
        rank:"genus"
        upper:"timaliidae"

    }
    {
        sc:"acridotheres"
        ja:"ハッカチョウ属"
        rank:"genus"
        upper:"sturnidae"

    }
    {
        sc:"gracupica"
        ja:"クビワムクドリ属"
        rank:"genus"
        upper:"sturnidae"

    }
    {
        sc:"ploceus"
        ja:"キハタオリ属"
        rank:"genus"
        upper:"ploceidae"

    }
    {
        sc:"euplectes"
        ja:"キンランチョウ属"
        rank:"genus"
        upper:"ploceidae"

    }
    {
        sc:"estrilda"
        ja:"カエデチョウ属"
        rank:"genus"
        upper:"estrildidae"

    }
    {
        sc:"amandava"
        ja:"ベニスズメ属"
        rank:"genus"
        upper:"estrildidae"

    }
    {
        sc:"lonchura"
        ja:"キンパラ属"
        rank:"genus"
        upper:"estrildidae"

    }
    {
        sc:"vidua"
        ja:"テンニンチョウ属"
        rank:"genus"
        upper:"viduidae"

    }
    {
        sc:"paroaria"
        ja:"コウカンチョウ属"
        rank:"genus"
        upper:"thraupidae"

    }
    ,{
        "alien":false,
        upper:"tetrastes"
        rank:"species"
        sc:"bonasia"
        ja:"エゾライチョウ"
    }
    {
        "alien":false,
        upper:"lagopus"
        rank:"species"
        sc:"muta"
        ja:"ライチョウ"
    }
    {
        "alien":false,
        upper:"coturnix"
        rank:"species"
        sc:"japonica"
        ja:"ウズラ"
    }
    {
        "alien":false,
        upper:"syrmaticus"
        rank:"species"
        sc:"soemmerringii"
        ja:"ヤマドリ"
    }
    {
        "alien":false,
        upper:"phasianus"
        rank:"species"
        sc:"colchicus"
        ja:"キジ"
    }
    {
        "alien":false,
        upper:"dendrocygna"
        rank:"species"
        sc:"javanica"
        ja:"リュウキュウガモ"
    }
    {
        "alien":false,
        upper:"anser"
        rank:"species"
        sc:"cygnoides"
        ja:"サカツラガン"
    }
    {
        "alien":false,
        upper:"anser"
        rank:"species"
        sc:"fabalis"
        ja:"ヒシクイ"
    }
    {
        "alien":false,
        upper:"anser"
        rank:"species"
        sc:"anser"
        ja:"ハイイロガン"
    }
    {
        "alien":false,
        upper:"anser"
        rank:"species"
        sc:"albifrons"
        ja:"マガン"
    }
    {
        "alien":false,
        upper:"anser"
        rank:"species"
        sc:"erythropus"
        ja:"カリガネ"
    }
    {
        "alien":false,
        upper:"anser"
        rank:"species"
        sc:"indicus"
        ja:"インドガン"
    }
    {
        "alien":false,
        upper:"anser"
        rank:"species"
        sc:"caerulescens"
        ja:"ハクガン"
    }
    {
        "alien":false,
        upper:"anser"
        rank:"species"
        sc:"canagicus"
        ja:"ミカドガン"
    }
    {
        "alien":false,
        upper:"branta"
        rank:"species"
        sc:"hutchinsii"
        ja:"シジュウカラガン"
    }
    {
        "alien":false,
        upper:"branta"
        rank:"species"
        sc:"bernicla"
        ja:"コクガン"
    }
    {
        "alien":false,
        upper:"cygnus"
        rank:"species"
        sc:"olor"
        ja:"コブハクチョウ"
    }
    {
        "alien":false,
        upper:"cygnus"
        rank:"species"
        sc:"buccinator"
        ja:"ナキハクチョウ"
    }
    {
        "alien":false,
        upper:"cygnus"
        rank:"species"
        sc:"columbianus"
        ja:"コハクチョウ"
    }
    {
        "alien":false,
        upper:"cygnus"
        rank:"species"
        sc:"cygnus"
        ja:"オオハクチョウ"
    }
    {
        "alien":false,
        upper:"tadorna"
        rank:"species"
        sc:"tadorna"
        ja:"ツクシガモ"
    }
    {
        "alien":false,
        upper:"tadorna"
        rank:"species"
        sc:"ferruginea"
        ja:"アカツクシガモ"
    }
    {
        "alien":false,
        upper:"tadorna"
        rank:"species"
        sc:"cristata"
        ja:"カンムリツクシガモ"
    }
    {
        "alien":false,
        upper:"aix"
        rank:"species"
        sc:"galericulata"
        ja:"オシドリ"
    }
    {
        "alien":false,
        upper:"nettapus"
        rank:"species"
        sc:"coromandelianus"
        ja:"ナンキンオシ"
    }
    {
        "alien":false,
        upper:"anas"
        rank:"species"
        sc:"strepera"
        ja:"オカヨシガモ"
    }
    {
        "alien":false,
        upper:"anas"
        rank:"species"
        sc:"falcata"
        ja:"ヨシガモ"
    }
    {
        "alien":false,
        upper:"anas"
        rank:"species"
        sc:"penelope"
        ja:"ヒドリガモ"
    }
    {
        "alien":false,
        upper:"anas"
        rank:"species"
        sc:"americana"
        ja:"アメリカヒドリ"
    }
    {
        "alien":false,
        upper:"anas"
        rank:"species"
        sc:"platyrhynchos"
        ja:"マガモ"
    }
    {
        "alien":false,
        upper:"anas"
        rank:"species"
        sc:"luzonica"
        ja:"アカノドカルガモ"
    }
    {
        "alien":false,
        upper:"anas"
        rank:"species"
        sc:"zonorhyncha"
        ja:"カルガモ"
    }
    {
        "alien":false,
        upper:"anas"
        rank:"species"
        sc:"discors"
        ja:"ミカヅキシマアジ"
    }
    {
        "alien":false,
        upper:"anas"
        rank:"species"
        sc:"clypeata"
        ja:"ハシビロガモ"
    }
    {
        "alien":false,
        upper:"anas"
        rank:"species"
        sc:"acuta"
        ja:"オナガガモ"
    }
    {
        "alien":false,
        upper:"anas"
        rank:"species"
        sc:"querquedula"
        ja:"シマアジ"
    }
    {
        "alien":false,
        upper:"anas"
        rank:"species"
        sc:"formosa"
        ja:"トモエガモ"
    }
    {
        "alien":false,
        upper:"anas"
        rank:"species"
        sc:"crecca"
        ja:"コガモ"
    }
    {
        "alien":false,
        upper:"netta"
        rank:"species"
        sc:"rufina"
        ja:"アカハシハジロ"
    }
    {
        "alien":false,
        upper:"aythya"
        rank:"species"
        sc:"valisineria"
        ja:"オオホシハジロ"
    }
    {
        "alien":false,
        upper:"aythya"
        rank:"species"
        sc:"americana"
        ja:"アメリカホシハジロ"
    }
    {
        "alien":false,
        upper:"aythya"
        rank:"species"
        sc:"ferina"
        ja:"ホシハジロ"
    }
    {
        "alien":false,
        upper:"aythya"
        rank:"species"
        sc:"baeri"
        ja:"アカハジロ"
    }
    {
        "alien":false,
        upper:"aythya"
        rank:"species"
        sc:"nyroca"
        ja:"メジロガモ"
    }
    {
        "alien":false,
        upper:"aythya"
        rank:"species"
        sc:"collaris"
        ja:"クビワキンクロ"
    }
    {
        "alien":false,
        upper:"aythya"
        rank:"species"
        sc:"fuligula"
        ja:"キンクロハジロ"
    }
    {
        "alien":false,
        upper:"aythya"
        rank:"species"
        sc:"marila"
        ja:"スズガモ"
    }
    {
        "alien":false,
        upper:"aythya"
        rank:"species"
        sc:"affinis"
        ja:"コスズガモ"
    }
    {
        "alien":false,
        upper:"polysticta"
        rank:"species"
        sc:"stelleri"
        ja:"コケワタガモ"
    }
    {
        "alien":false,
        upper:"somateria"
        rank:"species"
        sc:"spectabilis"
        ja:"ケワタガモ"
    }
    {
        "alien":false,
        upper:"histrionicus"
        rank:"species"
        sc:"histrionicus"
        ja:"シノリガモ"
    }
    {
        "alien":false,
        upper:"melanitta"
        rank:"species"
        sc:"perspicillata"
        ja:"アラナミキンクロ"
    }
    {
        "alien":false,
        upper:"melanitta"
        rank:"species"
        sc:"fusca"
        ja:"ビロードキンクロ"
    }
    {
        "alien":false,
        upper:"melanitta"
        rank:"species"
        sc:"americana"
        ja:"クロガモ"
    }
    {
        "alien":false,
        upper:"clangula"
        rank:"species"
        sc:"hyemalis"
        ja:"コオリガモ"
    }
    {
        "alien":false,
        upper:"bucephala"
        rank:"species"
        sc:"albeola"
        ja:"ヒメハジロ"
    }
    {
        "alien":false,
        upper:"bucephala"
        rank:"species"
        sc:"clangula"
        ja:"ホオジロガモ"
    }
    {
        "alien":false,
        upper:"mergellus"
        rank:"species"
        sc:"albellus"
        ja:"ミコアイサ"
    }
    {
        "alien":false,
        upper:"mergus"
        rank:"species"
        sc:"merganser"
        ja:"カワアイサ"
    }
    {
        "alien":false,
        upper:"mergus"
        rank:"species"
        sc:"serrator"
        ja:"ウミアイサ"
    }
    {
        "alien":false,
        upper:"mergus"
        rank:"species"
        sc:"squamatus"
        ja:"コウライアイサ"
    }
    {
        "alien":false,
        upper:"tachybaptus"
        rank:"species"
        sc:"ruficollis"
        ja:"カイツブリ"
    }
    {
        "alien":false,
        upper:"podiceps"
        rank:"species"
        sc:"grisegena"
        ja:"アカエリカイツブリ"
    }
    {
        "alien":false,
        upper:"podiceps"
        rank:"species"
        sc:"cristatus"
        ja:"カンムリカイツブリ"
    }
    {
        "alien":false,
        upper:"podiceps"
        rank:"species"
        sc:"auritus"
        ja:"ミミカイツブリ"
    }
    {
        "alien":false,
        upper:"podiceps"
        rank:"species"
        sc:"nigricollis"
        ja:"ハジロカイツブリ"
    }
    {
        "alien":false,
        upper:"phaethon"
        rank:"species"
        sc:"rubricauda"
        ja:"アカオネッタイチョウ"
    }
    {
        "alien":false,
        upper:"phaethon"
        rank:"species"
        sc:"lepturus"
        ja:"シラオネッタイチョウ"
    }
    {
        "alien":false,
        upper:"syrrhaptes"
        rank:"species"
        sc:"paradoxus"
        ja:"サケイ"
    }
    {
        "alien":false,
        upper:"columba"
        rank:"species"
        sc:"oenas"
        ja:"ヒメモリバト"
    }
    {
        "alien":false,
        upper:"columba"
        rank:"species"
        sc:"janthina"
        ja:"カラスバト"
    }
    {
        "alien":false,
        upper:"columba"
        rank:"species"
        sc:"versicolor"
        ja:"オガサワラカラスバト"
    }
    {
        "alien":false,
        upper:"columba"
        rank:"species"
        sc:"jouyi"
        ja:"リュウキュウカラスバト"
    }
    {
        "alien":false,
        upper:"streptopelia"
        rank:"species"
        sc:"orientalis"
        ja:"キジバト"
    }
    {
        "alien":false,
        upper:"streptopelia"
        rank:"species"
        sc:"decaocto"
        ja:"シラコバト"
    }
    {
        "alien":false,
        upper:"streptopelia"
        rank:"species"
        sc:"tranquebarica"
        ja:"ベニバト"
    }
    {
        "alien":false,
        upper:"chalcophaps"
        rank:"species"
        sc:"indica"
        ja:"キンバト"
    }
    {
        "alien":false,
        upper:"treron"
        rank:"species"
        sc:"sieboldii"
        ja:"アオバト"
    }
    {
        "alien":false,
        upper:"treron"
        rank:"species"
        sc:"formosae"
        ja:"ズアカアオバト"
    }
    {
        "alien":false,
        upper:"ptilinopus"
        rank:"species"
        sc:"leclancheri"
        ja:"クロアゴヒメアオバト"
    }
    {
        "alien":false,
        upper:"gavia"
        rank:"species"
        sc:"stellata"
        ja:"アビ"
    }
    {
        "alien":false,
        upper:"gavia"
        rank:"species"
        sc:"arctica"
        ja:"オオハム"
    }
    {
        "alien":false,
        upper:"gavia"
        rank:"species"
        sc:"pacifica"
        ja:"シロエリオオハム"
    }
    {
        "alien":false,
        upper:"gavia"
        rank:"species"
        sc:"immer"
        ja:"ハシグロアビ"
    }
    {
        "alien":false,
        upper:"gavia"
        rank:"species"
        sc:"adamsii"
        ja:"ハシジロアビ"
    }
    {
        "alien":false,
        upper:"phoebastria"
        rank:"species"
        sc:"immutabilis"
        ja:"コアホウドリ"
    }
    {
        "alien":false,
        upper:"phoebastria"
        rank:"species"
        sc:"nigripes"
        ja:"クロアシアホウドリ"
    }
    {
        "alien":false,
        upper:"phoebastria"
        rank:"species"
        sc:"albatrus"
        ja:"アホウドリ"
    }
    {
        "alien":false,
        upper:"fulmarus"
        rank:"species"
        sc:"glacialis"
        ja:"フルマカモメ"
    }
    {
        "alien":false,
        upper:"pterodroma"
        rank:"species"
        sc:"solandri"
        ja:"ハジロミズナギドリ"
    }
    {
        "alien":false,
        upper:"pterodroma"
        rank:"species"
        sc:"externa"
        ja:"オオシロハラミズナギドリ"
    }
    {
        "alien":false,
        upper:"pterodroma"
        rank:"species"
        sc:"neglecta"
        ja:"カワリシロハラミズナギドリ"
    }
    {
        "alien":false,
        upper:"pterodroma"
        rank:"species"
        sc:"phaeopygia"
        ja:"ハワイシロハラミズナギドリ"
    }
    {
        "alien":false,
        upper:"pterodroma"
        rank:"species"
        sc:"inexpectata"
        ja:"マダラシロハラミズナギドリ"
    }
    {
        "alien":false,
        upper:"pterodroma"
        rank:"species"
        sc:"nigripennis"
        ja:"ハグロシロハラミズナギドリ"
    }
    {
        "alien":false,
        upper:"pterodroma"
        rank:"species"
        sc:"hypoleuca"
        ja:"シロハラミズナギドリ"
    }
    {
        "alien":false,
        upper:"pterodroma"
        rank:"species"
        sc:"longirostris"
        ja:"ヒメシロハラミズナギドリ"
    }
    {
        "alien":false,
        upper:"calonectris"
        rank:"species"
        sc:"leucomelas"
        ja:"オオミズナギドリ"
    }
    {
        "alien":false,
        upper:"puffinus"
        rank:"species"
        sc:"pacificus"
        ja:"オナガミズナギドリ"
    }
    {
        "alien":false,
        upper:"puffinus"
        rank:"species"
        sc:"bulleri"
        ja:"ミナミオナガミズナギドリ"
    }
    {
        "alien":false,
        upper:"puffinus"
        rank:"species"
        sc:"griseus"
        ja:"ハイイロミズナギドリ"
    }
    {
        "alien":false,
        upper:"puffinus"
        rank:"species"
        sc:"tenuirostris"
        ja:"ハシボソミズナギドリ"
    }
    {
        "alien":false,
        upper:"puffinus"
        rank:"species"
        sc:"creatopus"
        ja:"シロハラアカアシミズナギドリ"
    }
    {
        "alien":false,
        upper:"puffinus"
        rank:"species"
        sc:"carneipes"
        ja:"アカアシミズナギドリ"
    }
    {
        "alien":false,
        upper:"puffinus"
        rank:"species"
        sc:"nativitatis"
        ja:"コミズナギドリ"
    }
    {
        "alien":false,
        upper:"puffinus"
        rank:"species"
        sc:"puffinus"
        ja:"マンクスミズナギドリ"
    }
    {
        "alien":false,
        upper:"puffinus"
        rank:"species"
        sc:"newelli"
        ja:"ハワイセグロミズナギドリ"
    }
    {
        "alien":false,
        upper:"puffinus"
        rank:"species"
        sc:"lherminieri"
        ja:"セグロミズナギドリ"
    }
    {
        "alien":false,
        upper:"puffinus"
        rank:"species"
        sc:"bryani"
        ja:"オガサワラヒメミズナギドリ"
    }
    {
        "alien":false,
        upper:"bulweria"
        rank:"species"
        sc:"bulwerii"
        ja:"アナドリ"
    }
    {
        "alien":false,
        upper:"oceanites"
        rank:"species"
        sc:"oceanicus"
        ja:"アシナガウミツバメ"
    }
    {
        "alien":false,
        upper:"oceanodroma"
        rank:"species"
        sc:"castro"
        ja:"クロコシジロウミツバメ"
    }
    {
        "alien":false,
        upper:"oceanodroma"
        rank:"species"
        sc:"monorhis"
        ja:"ヒメクロウミツバメ"
    }
    {
        "alien":false,
        upper:"oceanodroma"
        rank:"species"
        sc:"leucorhoa"
        ja:"コシジロウミツバメ"
    }
    {
        "alien":false,
        upper:"oceanodroma"
        rank:"species"
        sc:"tristrami"
        ja:"オーストンウミツバメ"
    }
    {
        "alien":false,
        upper:"oceanodroma"
        rank:"species"
        sc:"matsudairae"
        ja:"クロウミツバメ"
    }
    {
        "alien":false,
        upper:"oceanodroma"
        rank:"species"
        sc:"furcata"
        ja:"ハイイロウミツバメ"
    }
    {
        "alien":false,
        upper:"ciconia"
        rank:"species"
        sc:"nigra"
        ja:"ナベコウ"
    }
    {
        "alien":false,
        upper:"ciconia"
        rank:"species"
        sc:"boyciana"
        ja:"コウノトリ"
    }
    {
        "alien":false,
        upper:"fregata"
        rank:"species"
        sc:"minor"
        ja:"オオグンカンドリ"
    }
    {
        "alien":false,
        upper:"fregata"
        rank:"species"
        sc:"ariel"
        ja:"コグンカンドリ"
    }
    {
        "alien":false,
        upper:"sula"
        rank:"species"
        sc:"dactylatra"
        ja:"アオツラカツオドリ"
    }
    {
        "alien":false,
        upper:"sula"
        rank:"species"
        sc:"sula"
        ja:"アカアシカツオドリ"
    }
    {
        "alien":false,
        upper:"sula"
        rank:"species"
        sc:"leucogaster"
        ja:"カツオドリ"
    }
    {
        "alien":false,
        upper:"phalacrocorax"
        rank:"species"
        sc:"pelagicus"
        ja:"ヒメウ"
    }
    {
        "alien":false,
        upper:"phalacrocorax"
        rank:"species"
        sc:"urile"
        ja:"チシマウガラス"
    }
    {
        "alien":false,
        upper:"phalacrocorax"
        rank:"species"
        sc:"carbo"
        ja:"カワウ"
    }
    {
        "alien":false,
        upper:"phalacrocorax"
        rank:"species"
        sc:"capillatus"
        ja:"ウミウ"
    }
    {
        "alien":false,
        upper:"pelecanus"
        rank:"species"
        sc:"onocrotalus"
        ja:"モモイロペリカン"
    }
    {
        "alien":false,
        upper:"pelecanus"
        rank:"species"
        sc:"philippensis"
        ja:"ホシバシペリカン"
    }
    {
        "alien":false,
        upper:"pelecanus"
        rank:"species"
        sc:"crispus"
        ja:"ハイイロペリカン"
    }
    {
        "alien":false,
        upper:"botaurus"
        rank:"species"
        sc:"stellaris"
        ja:"サンカノゴイ"
    }
    {
        "alien":false,
        upper:"ixobrychus"
        rank:"species"
        sc:"sinensis"
        ja:"ヨシゴイ"
    }
    {
        "alien":false,
        upper:"ixobrychus"
        rank:"species"
        sc:"eurhythmus"
        ja:"オオヨシゴイ"
    }
    {
        "alien":false,
        upper:"ixobrychus"
        rank:"species"
        sc:"cinnamomeus"
        ja:"リュウキュウヨシゴイ"
    }
    {
        "alien":false,
        upper:"ixobrychus"
        rank:"species"
        sc:"flavicollis"
        ja:"タカサゴクロサギ"
    }
    {
        "alien":false,
        upper:"gorsachius"
        rank:"species"
        sc:"goisagi"
        ja:"ミゾゴイ"
    }
    {
        "alien":false,
        upper:"gorsachius"
        rank:"species"
        sc:"melanolophus"
        ja:"ズグロミゾゴイ"
    }
    {
        "alien":false,
        upper:"nycticorax"
        rank:"species"
        sc:"nycticorax"
        ja:"ゴイサギ"
    }
    {
        "alien":false,
        upper:"nycticorax"
        rank:"species"
        sc:"caledonicus"
        ja:"ハシブトゴイ"
    }
    {
        "alien":false,
        upper:"butorides"
        rank:"species"
        sc:"striata"
        ja:"ササゴイ"
    }
    {
        "alien":false,
        upper:"ardeola"
        rank:"species"
        sc:"bacchus"
        ja:"アカガシラサギ"
    }
    {
        "alien":false,
        upper:"bubulcus"
        rank:"species"
        sc:"ibis"
        ja:"アマサギ"
    }
    {
        "alien":false,
        upper:"ardea"
        rank:"species"
        sc:"cinerea"
        ja:"アオサギ"
    }
    {
        "alien":false,
        upper:"ardea"
        rank:"species"
        sc:"purpurea"
        ja:"ムラサキサギ"
    }
    {
        "alien":false,
        upper:"ardea"
        rank:"species"
        sc:"alba"
        ja:"ダイサギ"
    }
    {
        "alien":false,
        upper:"egretta"
        rank:"species"
        sc:"intermedia"
        ja:"チュウサギ"
    }
    {
        "alien":false,
        upper:"egretta"
        rank:"species"
        sc:"garzetta"
        ja:"コサギ"
    }
    {
        "alien":false,
        upper:"egretta"
        rank:"species"
        sc:"sacra"
        ja:"クロサギ"
    }
    {
        "alien":false,
        upper:"egretta"
        rank:"species"
        sc:"eulophotes"
        ja:"カラシラサギ"
    }
    {
        "alien":false,
        upper:"threskiornis"
        rank:"species"
        sc:"melanocephalus"
        ja:"クロトキ"
    }
    {
        "alien":false,
        upper:"nipponia"
        rank:"species"
        sc:"nippon"
        ja:"トキ"
    }
    {
        "alien":false,
        upper:"platalea"
        rank:"species"
        sc:"leucorodia"
        ja:"ヘラサギ"
    }
    {
        "alien":false,
        upper:"platalea"
        rank:"species"
        sc:"minor"
        ja:"クロツラヘラサギ"
    }
    {
        "alien":false,
        upper:"grus"
        rank:"species"
        sc:"leucogeranus"
        ja:"ソデグロヅル"
    }
    {
        "alien":false,
        upper:"grus"
        rank:"species"
        sc:"canadensis"
        ja:"カナダヅル"
    }
    {
        "alien":false,
        upper:"grus"
        rank:"species"
        sc:"vipio"
        ja:"マナヅル"
    }
    {
        "alien":false,
        upper:"grus"
        rank:"species"
        sc:"japonensis"
        ja:"タンチョウ"
    }
    {
        "alien":false,
        upper:"grus"
        rank:"species"
        sc:"grus"
        ja:"クロヅル"
    }
    {
        "alien":false,
        upper:"grus"
        rank:"species"
        sc:"monacha"
        ja:"ナベヅル"
    }
    {
        "alien":false,
        upper:"anthropoides"
        rank:"species"
        sc:"virgo"
        ja:"アネハヅル"
    }
    {
        "alien":false,
        upper:"coturnicops"
        rank:"species"
        sc:"exquisitus"
        ja:"シマクイナ"
    }
    {
        "alien":false,
        upper:"rallina"
        rank:"species"
        sc:"eurizonoides"
        ja:"オオクイナ"
    }
    {
        "alien":false,
        upper:"gallirallus"
        rank:"species"
        sc:"okinawae"
        ja:"ヤンバルクイナ"
    }
    {
        "alien":false,
        upper:"gallirallus"
        rank:"species"
        sc:"striatus"
        ja:"ミナミクイナ"
    }
    {
        "alien":false,
        upper:"rallus"
        rank:"species"
        sc:"aquaticus"
        ja:"クイナ"
    }
    {
        "alien":false,
        upper:"amaurornis"
        rank:"species"
        sc:"phoenicurus"
        ja:"シロハラクイナ"
    }
    {
        "alien":false,
        upper:"porzana"
        rank:"species"
        sc:"pusilla"
        ja:"ヒメクイナ"
    }
    {
        "alien":false,
        upper:"porzana"
        rank:"species"
        sc:"porzana"
        ja:"コモンクイナ"
    }
    {
        "alien":false,
        upper:"porzana"
        rank:"species"
        sc:"fusca"
        ja:"ヒクイナ"
    }
    {
        "alien":false,
        upper:"porzana"
        rank:"species"
        sc:"paykullii"
        ja:"コウライクイナ"
    }
    {
        "alien":false,
        upper:"porzana"
        rank:"species"
        sc:"cinerea"
        ja:"マミジロクイナ"
    }
    {
        "alien":false,
        upper:"gallicrex"
        rank:"species"
        sc:"cinerea"
        ja:"ツルクイナ"
    }
    {
        "alien":false,
        upper:"gallinula"
        rank:"species"
        sc:"chloropus"
        ja:"バン"
    }
    {
        "alien":false,
        upper:"fulica"
        rank:"species"
        sc:"atra"
        ja:"オオバン"
    }
    {
        "alien":false,
        upper:"otis"
        rank:"species"
        sc:"tarda"
        ja:"ノガン"
    }
    {
        "alien":false,
        upper:"tetrax"
        rank:"species"
        sc:"tetrax"
        ja:"ヒメノガン"
    }
    {
        "alien":false,
        upper:"centropus"
        rank:"species"
        sc:"bengalensis"
        ja:"バンケン"
    }
    {
        "alien":false,
        upper:"clamator"
        rank:"species"
        sc:"coromandus"
        ja:"カンムリカッコウ"
    }
    {
        "alien":false,
        upper:"eudynamys"
        rank:"species"
        sc:"scolopaceus"
        ja:"オニカッコウ"
    }
    {
        "alien":false,
        upper:"urodynamis"
        rank:"species"
        sc:"taitensis"
        ja:"キジカッコウ"
    }
    {
        "alien":false,
        upper:"surniculus"
        rank:"species"
        sc:"lugubris"
        ja:"オウチュウカッコウ"
    }
    {
        "alien":false,
        upper:"hierococcyx"
        rank:"species"
        sc:"sparverioides"
        ja:"オオジュウイチ"
    }
    {
        "alien":false,
        upper:"hierococcyx"
        rank:"species"
        sc:"hyperythrus"
        ja:"ジュウイチ"
    }
    {
        "alien":false,
        upper:"cuculus"
        rank:"species"
        sc:"poliocephalus"
        ja:"ホトトギス"
    }
    {
        "alien":false,
        upper:"cuculus"
        rank:"species"
        sc:"micropterus"
        ja:"セグロカッコウ"
    }
    {
        "alien":false,
        upper:"cuculus"
        rank:"species"
        sc:"optatus"
        ja:"ツツドリ"
    }
    {
        "alien":false,
        upper:"cuculus"
        rank:"species"
        sc:"canorus"
        ja:"カッコウ"
    }
    {
        "alien":false,
        upper:"caprimulgus"
        rank:"species"
        sc:"indicus"
        ja:"ヨタカ"
    }
    {
        "alien":false,
        upper:"aerodramus"
        rank:"species"
        sc:"brevirostris"
        ja:"ヒマラヤアナツバメ"
    }
    {
        "alien":false,
        upper:"hirundapus"
        rank:"species"
        sc:"caudacutus"
        ja:"ハリオアマツバメ"
    }
    {
        "alien":false,
        upper:"apus"
        rank:"species"
        sc:"pacificus"
        ja:"アマツバメ"
    }
    {
        "alien":false,
        upper:"apus"
        rank:"species"
        sc:"nipalensis"
        ja:"ヒメアマツバメ"
    }
    {
        "alien":false,
        upper:"vanellus"
        rank:"species"
        sc:"vanellus"
        ja:"タゲリ"
    }
    {
        "alien":false,
        upper:"vanellus"
        rank:"species"
        sc:"cinereus"
        ja:"ケリ"
    }
    {
        "alien":false,
        upper:"pluvialis"
        rank:"species"
        sc:"apricaria"
        ja:"ヨーロッパムナグロ"
    }
    {
        "alien":false,
        upper:"pluvialis"
        rank:"species"
        sc:"fulva"
        ja:"ムナグロ"
    }
    {
        "alien":false,
        upper:"pluvialis"
        rank:"species"
        sc:"dominica"
        ja:"アメリカムナグロ"
    }
    {
        "alien":false,
        upper:"pluvialis"
        rank:"species"
        sc:"squatarola"
        ja:"ダイゼン"
    }
    {
        "alien":false,
        upper:"charadrius"
        rank:"species"
        sc:"hiaticula"
        ja:"ハジロコチドリ"
    }
    {
        "alien":false,
        upper:"charadrius"
        rank:"species"
        sc:"semipalmatus"
        ja:"ミズカキチドリ"
    }
    {
        "alien":false,
        upper:"charadrius"
        rank:"species"
        sc:"placidus"
        ja:"イカルチドリ"
    }
    {
        "alien":false,
        upper:"charadrius"
        rank:"species"
        sc:"dubius"
        ja:"コチドリ"
    }
    {
        "alien":false,
        upper:"charadrius"
        rank:"species"
        sc:"alexandrinus"
        ja:"シロチドリ"
    }
    {
        "alien":false,
        upper:"charadrius"
        rank:"species"
        sc:"mongolus"
        ja:"メダイチドリ"
    }
    {
        "alien":false,
        upper:"charadrius"
        rank:"species"
        sc:"leschenaultii"
        ja:"オオメダイチドリ"
    }
    {
        "alien":false,
        upper:"charadrius"
        rank:"species"
        sc:"veredus"
        ja:"オオチドリ"
    }
    {
        "alien":false,
        upper:"charadrius"
        rank:"species"
        sc:"morinellus"
        ja:"コバシチドリ"
    }
    {
        "alien":false,
        upper:"haematopus"
        rank:"species"
        sc:"ostralegus"
        ja:"ミヤコドリ"
    }
    {
        "alien":false,
        upper:"himantopus"
        rank:"species"
        sc:"himantopus"
        ja:"セイタカシギ"
    }
    {
        "alien":false,
        upper:"recurvirostra"
        rank:"species"
        sc:"avosetta"
        ja:"ソリハシセイタカシギ"
    }
    {
        "alien":false,
        upper:"scolopax"
        rank:"species"
        sc:"rusticola"
        ja:"ヤマシギ"
    }
    {
        "alien":false,
        upper:"scolopax"
        rank:"species"
        sc:"mira"
        ja:"アマミヤマシギ"
    }
    {
        "alien":false,
        upper:"lymnocryptes"
        rank:"species"
        sc:"minimus"
        ja:"コシギ"
    }
    {
        "alien":false,
        upper:"gallinago"
        rank:"species"
        sc:"solitaria"
        ja:"アオシギ"
    }
    {
        "alien":false,
        upper:"gallinago"
        rank:"species"
        sc:"hardwickii"
        ja:"オオジシギ"
    }
    {
        "alien":false,
        upper:"gallinago"
        rank:"species"
        sc:"stenura"
        ja:"ハリオシギ"
    }
    {
        "alien":false,
        upper:"gallinago"
        rank:"species"
        sc:"megala"
        ja:"チュウジシギ"
    }
    {
        "alien":false,
        upper:"gallinago"
        rank:"species"
        sc:"gallinago"
        ja:"タシギ"
    }
    {
        "alien":false,
        upper:"limnodromus"
        rank:"species"
        sc:"griseus"
        ja:"アメリカオオハシシギ"
    }
    {
        "alien":false,
        upper:"limnodromus"
        rank:"species"
        sc:"scolopaceus"
        ja:"オオハシシギ"
    }
    {
        "alien":false,
        upper:"limnodromus"
        rank:"species"
        sc:"semipalmatus"
        ja:"シベリアオオハシシギ"
    }
    {
        "alien":false,
        upper:"limosa"
        rank:"species"
        sc:"limosa"
        ja:"オグロシギ"
    }
    {
        "alien":false,
        upper:"limosa"
        rank:"species"
        sc:"haemastica"
        ja:"アメリカオグロシギ"
    }
    {
        "alien":false,
        upper:"limosa"
        rank:"species"
        sc:"lapponica"
        ja:"オオソリハシシギ"
    }
    {
        "alien":false,
        upper:"numenius"
        rank:"species"
        sc:"minutus"
        ja:"コシャクシギ"
    }
    {
        "alien":false,
        upper:"numenius"
        rank:"species"
        sc:"phaeopus"
        ja:"チュウシャクシギ"
    }
    {
        "alien":false,
        upper:"numenius"
        rank:"species"
        sc:"tahitiensis"
        ja:"ハリモモチュウシャク"
    }
    {
        "alien":false,
        upper:"numenius"
        rank:"species"
        sc:"tenuirostris"
        ja:"シロハラチュウシャクシギ"
    }
    {
        "alien":false,
        upper:"numenius"
        rank:"species"
        sc:"arquata"
        ja:"ダイシャクシギ"
    }
    {
        "alien":false,
        upper:"numenius"
        rank:"species"
        sc:"madagascariensis"
        ja:"ホウロクシギ"
    }
    {
        "alien":false,
        upper:"tringa"
        rank:"species"
        sc:"erythropus"
        ja:"ツルシギ"
    }
    {
        "alien":false,
        upper:"tringa"
        rank:"species"
        sc:"totanus"
        ja:"アカアシシギ"
    }
    {
        "alien":false,
        upper:"tringa"
        rank:"species"
        sc:"stagnatilis"
        ja:"コアオアシシギ"
    }
    {
        "alien":false,
        upper:"tringa"
        rank:"species"
        sc:"nebularia"
        ja:"アオアシシギ"
    }
    {
        "alien":false,
        upper:"tringa"
        rank:"species"
        sc:"guttifer"
        ja:"カラフトアオアシシギ"
    }
    {
        "alien":false,
        upper:"tringa"
        rank:"species"
        sc:"melanoleuca"
        ja:"オオキアシシギ"
    }
    {
        "alien":false,
        upper:"tringa"
        rank:"species"
        sc:"flavipes"
        ja:"コキアシシギ"
    }
    {
        "alien":false,
        upper:"tringa"
        rank:"species"
        sc:"ochropus"
        ja:"クサシギ"
    }
    {
        "alien":false,
        upper:"tringa"
        rank:"species"
        sc:"glareola"
        ja:"タカブシギ"
    }
    {
        "alien":false,
        upper:"heteroscelus"
        rank:"species"
        sc:"brevipes"
        ja:"キアシシギ"
    }
    {
        "alien":false,
        upper:"heteroscelus"
        rank:"species"
        sc:"incanus"
        ja:"メリケンキアシシギ"
    }
    {
        "alien":false,
        upper:"xenus"
        rank:"species"
        sc:"cinereus"
        ja:"ソリハシシギ"
    }
    {
        "alien":false,
        upper:"actitis"
        rank:"species"
        sc:"hypoleucos"
        ja:"イソシギ"
    }
    {
        "alien":false,
        upper:"actitis"
        rank:"species"
        sc:"macularius"
        ja:"アメリカイソシギ"
    }
    {
        "alien":false,
        upper:"arenaria"
        rank:"species"
        sc:"interpres"
        ja:"キョウジョシギ"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"tenuirostris"
        ja:"オバシギ"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"canutus"
        ja:"コオバシギ"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"alba"
        ja:"ミユビシギ"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"mauri"
        ja:"ヒメハマシギ"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"ruficollis"
        ja:"トウネン"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"minuta"
        ja:"ヨーロッパトウネン"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"temminckii"
        ja:"オジロトウネン"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"subminuta"
        ja:"ヒバリシギ"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"fuscicollis"
        ja:"コシジロウズラシギ"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"bairdii"
        ja:"ヒメウズラシギ"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"melanotos"
        ja:"アメリカウズラシギ"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"acuminata"
        ja:"ウズラシギ"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"ferruginea"
        ja:"サルハマシギ"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"ptilocnemis"
        ja:"チシマシギ"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"alpina"
        ja:"ハマシギ"
    }
    {
        "alien":false,
        upper:"calidris"
        rank:"species"
        sc:"himantopus"
        ja:"アシナガシギ"
    }
    {
        "alien":false,
        upper:"eurynorhynchus"
        rank:"species"
        sc:"pygmeus"
        ja:"ヘラシギ"
    }
    {
        "alien":false,
        upper:"limicola"
        rank:"species"
        sc:"falcinellus"
        ja:"キリアイ"
    }
    {
        "alien":false,
        upper:"tryngites"
        rank:"species"
        sc:"subruficollis"
        ja:"コモンシギ"
    }
    {
        "alien":false,
        upper:"philomachus"
        rank:"species"
        sc:"pugnax"
        ja:"エリマキシギ"
    }
    {
        "alien":false,
        upper:"phalaropus"
        rank:"species"
        sc:"tricolor"
        ja:"アメリカヒレアシシギ"
    }
    {
        "alien":false,
        upper:"phalaropus"
        rank:"species"
        sc:"lobatus"
        ja:"アカエリヒレアシシギ"
    }
    {
        "alien":false,
        upper:"phalaropus"
        rank:"species"
        sc:"fulicarius"
        ja:"ハイイロヒレアシシギ"
    }
    {
        "alien":false,
        upper:"hydrophasianus"
        rank:"species"
        sc:"chirurgus"
        ja:"レンカク"
    }
    {
        "alien":false,
        upper:"rostratula"
        rank:"species"
        sc:"benghalensis"
        ja:"タマシギ"
    }
    {
        "alien":false,
        upper:"turnix"
        rank:"species"
        sc:"suscitator"
        ja:"ミフウズラ"
    }
    {
        "alien":false,
        upper:"glareola"
        rank:"species"
        sc:"maldivarum"
        ja:"ツバメチドリ"
    }
    {
        "alien":false,
        upper:"anous"
        rank:"species"
        sc:"stolidus"
        ja:"クロアジサシ"
    }
    {
        "alien":false,
        upper:"anous"
        rank:"species"
        sc:"minutus"
        ja:"ヒメクロアジサシ"
    }
    {
        "alien":false,
        upper:"procelsterna"
        rank:"species"
        sc:"cerulea"
        ja:"ハイイロアジサシ"
    }
    {
        "alien":false,
        upper:"gygis"
        rank:"species"
        sc:"alba"
        ja:"シロアジサシ"
    }
    {
        "alien":false,
        upper:"rissa"
        rank:"species"
        sc:"tridactyla"
        ja:"ミツユビカモメ"
    }
    {
        "alien":false,
        upper:"rissa"
        rank:"species"
        sc:"brevirostris"
        ja:"アカアシミツユビカモメ"
    }
    {
        "alien":false,
        upper:"pagophila"
        rank:"species"
        sc:"eburnea"
        ja:"ゾウゲカモメ"
    }
    {
        "alien":false,
        upper:"xema"
        rank:"species"
        sc:"sabini"
        ja:"クビワカモメ"
    }
    {
        "alien":false,
        upper:"rhodostethia"
        rank:"species"
        sc:"rosea"
        ja:"ヒメクビワカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"genei"
        ja:"ハシボソカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"philadelphia"
        ja:"ボナパルトカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"brunnicephalus"
        ja:"チャガシラカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"ridibundus"
        ja:"ユリカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"saundersi"
        ja:"ズグロカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"minutus"
        ja:"ヒメカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"atricilla"
        ja:"ワライカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"pipixcan"
        ja:"アメリカズグロカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"relictus"
        ja:"ゴビズキンカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"ichthyaetus"
        ja:"オオズグロカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"crassirostris"
        ja:"ウミネコ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"canus"
        ja:"カモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"glaucescens"
        ja:"ワシカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"hyperboreus"
        ja:"シロカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"glaucoides"
        ja:"アイスランドカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"thayeri"
        ja:"カナダカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"argentatus"
        ja:"セグロカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"cachinnans"
        ja:"キアシセグロカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"schistisagus"
        ja:"オオセグロカモメ"
    }
    {
        "alien":false,
        upper:"larus"
        rank:"species"
        sc:"fuscus"
        ja:"ニシセグロカモメ"
    }
    {
        "alien":false,
        upper:"gelochelidon"
        rank:"species"
        sc:"nilotica"
        ja:"ハシブトアジサシ"
    }
    {
        "alien":false,
        upper:"sterna"
        rank:"species"
        sc:"caspia"
        ja:"オニアジサシ"
    }
    {
        "alien":false,
        upper:"sterna"
        rank:"species"
        sc:"bergii"
        ja:"オオアジサシ"
    }
    {
        "alien":false,
        upper:"sterna"
        rank:"species"
        sc:"bengalensis"
        ja:"ベンガルアジサシ"
    }
    {
        "alien":false,
        upper:"sterna"
        rank:"species"
        sc:"albifrons"
        ja:"コアジサシ"
    }
    {
        "alien":false,
        upper:"sterna"
        rank:"species"
        sc:"aleutica"
        ja:"コシジロアジサシ"
    }
    {
        "alien":false,
        upper:"sterna"
        rank:"species"
        sc:"lunata"
        ja:"ナンヨウマミジロアジサシ"
    }
    {
        "alien":false,
        upper:"sterna"
        rank:"species"
        sc:"anaethetus"
        ja:"マミジロアジサシ"
    }
    {
        "alien":false,
        upper:"sterna"
        rank:"species"
        sc:"fuscata"
        ja:"セグロアジサシ"
    }
    {
        "alien":false,
        upper:"sterna"
        rank:"species"
        sc:"dougallii"
        ja:"ベニアジサシ"
    }
    {
        "alien":false,
        upper:"sterna"
        rank:"species"
        sc:"sumatrana"
        ja:"エリグロアジサシ"
    }
    {
        "alien":false,
        upper:"sterna"
        rank:"species"
        sc:"hirundo"
        ja:"アジサシ"
    }
    {
        "alien":false,
        upper:"sterna"
        rank:"species"
        sc:"paradisaea"
        ja:"キョクアジサシ"
    }
    {
        "alien":false,
        upper:"chlidonias"
        rank:"species"
        sc:"hybrida"
        ja:"クロハラアジサシ"
    }
    {
        "alien":false,
        upper:"chlidonias"
        rank:"species"
        sc:"leucopterus"
        ja:"ハジロクロハラアジサシ"
    }
    {
        "alien":false,
        upper:"chlidonias"
        rank:"species"
        sc:"niger"
        ja:"ハシグロクロハラアジサシ"
    }
    {
        "alien":false,
        upper:"stercorarius"
        rank:"species"
        sc:"maccormicki"
        ja:"オオトウゾクカモメ"
    }
    {
        "alien":false,
        upper:"stercorarius"
        rank:"species"
        sc:"pomarinus"
        ja:"トウゾクカモメ"
    }
    {
        "alien":false,
        upper:"stercorarius"
        rank:"species"
        sc:"parasiticus"
        ja:"クロトウゾクカモメ"
    }
    {
        "alien":false,
        upper:"stercorarius"
        rank:"species"
        sc:"longicaudus"
        ja:"シロハラトウゾクカモメ"
    }
    {
        "alien":false,
        upper:"alle"
        rank:"species"
        sc:"alle"
        ja:"ヒメウミスズメ"
    }
    {
        "alien":false,
        upper:"uria"
        rank:"species"
        sc:"lomvia"
        ja:"ハシブトウミガラス"
    }
    {
        "alien":false,
        upper:"uria"
        rank:"species"
        sc:"aalge"
        ja:"ウミガラス"
    }
    {
        "alien":false,
        upper:"alca"
        rank:"species"
        sc:"torda"
        ja:"オオハシウミガラス"
    }
    {
        "alien":false,
        upper:"cepphus"
        rank:"species"
        sc:"columba"
        ja:"ウミバト"
    }
    {
        "alien":false,
        upper:"cepphus"
        rank:"species"
        sc:"carbo"
        ja:"ケイマフリ"
    }
    {
        "alien":false,
        upper:"brachyramphus"
        rank:"species"
        sc:"perdix"
        ja:"マダラウミスズメ"
    }
    {
        "alien":false,
        upper:"synthliboramphus"
        rank:"species"
        sc:"antiquus"
        ja:"ウミスズメ"
    }
    {
        "alien":false,
        upper:"synthliboramphus"
        rank:"species"
        sc:"wumizusume"
        ja:"カンムリウミスズメ"
    }
    {
        "alien":false,
        upper:"aethia"
        rank:"species"
        sc:"psittacula"
        ja:"ウミオウム"
    }
    {
        "alien":false,
        upper:"aethia"
        rank:"species"
        sc:"pusilla"
        ja:"コウミスズメ"
    }
    {
        "alien":false,
        upper:"aethia"
        rank:"species"
        sc:"pygmaea"
        ja:"シラヒゲウミスズメ"
    }
    {
        "alien":false,
        upper:"aethia"
        rank:"species"
        sc:"cristatella"
        ja:"エトロフウミスズメ"
    }
    {
        "alien":false,
        upper:"cerorhinca"
        rank:"species"
        sc:"monocerata"
        ja:"ウトウ"
    }
    {
        "alien":false,
        upper:"fratercula"
        rank:"species"
        sc:"corniculata"
        ja:"ツノメドリ"
    }
    {
        "alien":false,
        upper:"fratercula"
        rank:"species"
        sc:"cirrhata"
        ja:"エトピリカ"
    }
    {
        "alien":false,
        upper:"pandion"
        rank:"species"
        sc:"haliaetus"
        ja:"ミサゴ"
    }
    {
        "alien":false,
        upper:"pernis"
        rank:"species"
        sc:"ptilorhynchus"
        ja:"ハチクマ"
    }
    {
        "alien":false,
        upper:"elanus"
        rank:"species"
        sc:"caeruleus"
        ja:"カタグロトビ"
    }
    {
        "alien":false,
        upper:"milvus"
        rank:"species"
        sc:"migrans"
        ja:"トビ"
    }
    {
        "alien":false,
        upper:"haliaeetus"
        rank:"species"
        sc:"albicilla"
        ja:"オジロワシ"
    }
    {
        "alien":false,
        upper:"haliaeetus"
        rank:"species"
        sc:"leucocephalus"
        ja:"ハクトウワシ"
    }
    {
        "alien":false,
        upper:"haliaeetus"
        rank:"species"
        sc:"pelagicus"
        ja:"オオワシ"
    }
    {
        "alien":false,
        upper:"aegypius"
        rank:"species"
        sc:"monachus"
        ja:"クロハゲワシ"
    }
    {
        "alien":false,
        upper:"spilornis"
        rank:"species"
        sc:"cheela"
        ja:"カンムリワシ"
    }
    {
        "alien":false,
        upper:"circus"
        rank:"species"
        sc:"aeruginosus"
        ja:"ヨーロッパチュウヒ"
    }
    {
        "alien":false,
        upper:"circus"
        rank:"species"
        sc:"spilonotus"
        ja:"チュウヒ"
    }
    {
        "alien":false,
        upper:"circus"
        rank:"species"
        sc:"cyaneus"
        ja:"ハイイロチュウヒ"
    }
    {
        "alien":false,
        upper:"circus"
        rank:"species"
        sc:"macrourus"
        ja:"ウスハイイロチュウヒ"
    }
    {
        "alien":false,
        upper:"circus"
        rank:"species"
        sc:"melanoleucos"
        ja:"マダラチュウヒ"
    }
    {
        "alien":false,
        upper:"accipiter"
        rank:"species"
        sc:"soloensis"
        ja:"アカハラダカ"
    }
    {
        "alien":false,
        upper:"accipiter"
        rank:"species"
        sc:"gularis"
        ja:"ツミ"
    }
    {
        "alien":false,
        upper:"accipiter"
        rank:"species"
        sc:"nisus"
        ja:"ハイタカ"
    }
    {
        "alien":false,
        upper:"accipiter"
        rank:"species"
        sc:"gentilis"
        ja:"オオタカ"
    }
    {
        "alien":false,
        upper:"butastur"
        rank:"species"
        sc:"indicus"
        ja:"サシバ"
    }
    {
        "alien":false,
        upper:"buteo"
        rank:"species"
        sc:"buteo"
        ja:"ノスリ"
    }
    {
        "alien":false,
        upper:"buteo"
        rank:"species"
        sc:"hemilasius"
        ja:"オオノスリ"
    }
    {
        "alien":false,
        upper:"buteo"
        rank:"species"
        sc:"lagopus"
        ja:"ケアシノスリ"
    }
    {
        "alien":false,
        upper:"aquila"
        rank:"species"
        sc:"clanga"
        ja:"カラフトワシ"
    }
    {
        "alien":false,
        upper:"aquila"
        rank:"species"
        sc:"heliaca"
        ja:"カタシロワシ"
    }
    {
        "alien":false,
        upper:"aquila"
        rank:"species"
        sc:"chrysaetos"
        ja:"イヌワシ"
    }
    {
        "alien":false,
        upper:"nisaetus"
        rank:"species"
        sc:"nipalensis"
        ja:"クマタカ"
    }
    {
        "alien":false,
        upper:"tyto"
        rank:"species"
        sc:"longimembris"
        ja:"ヒガシメンフクロウ"
    }
    {
        "alien":false,
        upper:"otus"
        rank:"species"
        sc:"lempiji"
        ja:"オオコノハズク"
    }
    {
        "alien":false,
        upper:"otus"
        rank:"species"
        sc:"sunia"
        ja:"コノハズク"
    }
    {
        "alien":false,
        upper:"otus"
        rank:"species"
        sc:"elegans"
        ja:"リュウキュウコノハズク"
    }
    {
        "alien":false,
        upper:"bubo"
        rank:"species"
        sc:"scandiacus"
        ja:"シロフクロウ"
    }
    {
        "alien":false,
        upper:"bubo"
        rank:"species"
        sc:"bubo"
        ja:"ワシミミズク"
    }
    {
        "alien":false,
        upper:"ketupa"
        rank:"species"
        sc:"blakistoni"
        ja:"シマフクロウ"
    }
    {
        "alien":false,
        upper:"strix"
        rank:"species"
        sc:"uralensis"
        ja:"フクロウ"
    }
    {
        "alien":false,
        upper:"aegolius"
        rank:"species"
        sc:"funereus"
        ja:"キンメフクロウ"
    }
    {
        "alien":false,
        upper:"ninox"
        rank:"species"
        sc:"scutulata"
        ja:"アオバズク"
    }
    {
        "alien":false,
        upper:"asio"
        rank:"species"
        sc:"otus"
        ja:"トラフズク"
    }
    {
        "alien":false,
        upper:"asio"
        rank:"species"
        sc:"flammeus"
        ja:"コミミズク"
    }
    {
        "alien":false,
        upper:"upupa"
        rank:"species"
        sc:"epops"
        ja:"ヤツガシラ"
    }
    {
        "alien":false,
        upper:"halcyon"
        rank:"species"
        sc:"coromanda"
        ja:"アカショウビン"
    }
    {
        "alien":false,
        upper:"halcyon"
        rank:"species"
        sc:"smyrnensis"
        ja:"アオショウビン"
    }
    {
        "alien":false,
        upper:"halcyon"
        rank:"species"
        sc:"pileata"
        ja:"ヤマショウビン"
    }
    {
        "alien":false,
        upper:"todiramphus"
        rank:"species"
        sc:"chloris"
        ja:"ナンヨウショウビン"
    }
    {
        "alien":false,
        upper:"todiramphus"
        rank:"species"
        sc:"miyakoensis"
        ja:"ミヤコショウビン"
    }
    {
        "alien":false,
        upper:"alcedo"
        rank:"species"
        sc:"atthis"
        ja:"カワセミ"
    }
    {
        "alien":false,
        upper:"ceyx"
        rank:"species"
        sc:"erithaca"
        ja:"ミツユビカワセミ"
    }
    {
        "alien":false,
        upper:"megaceryle"
        rank:"species"
        sc:"lugubris"
        ja:"ヤマセミ"
    }
    {
        "alien":false,
        upper:"merops"
        rank:"species"
        sc:"ornatus"
        ja:"ハチクイ"
    }
    {
        "alien":false,
        upper:"eurystomus"
        rank:"species"
        sc:"orientalis"
        ja:"ブッポウソウ"
    }
    {
        "alien":false,
        upper:"jynx"
        rank:"species"
        sc:"torquilla"
        ja:"アリスイ"
    }
    {
        "alien":false,
        upper:"dendrocopos"
        rank:"species"
        sc:"hyperythrus"
        ja:"チャバラアカゲラ"
    }
    {
        "alien":false,
        upper:"dendrocopos"
        rank:"species"
        sc:"kizuki"
        ja:"コゲラ"
    }
    {
        "alien":false,
        upper:"dendrocopos"
        rank:"species"
        sc:"minor"
        ja:"コアカゲラ"
    }
    {
        "alien":false,
        upper:"dendrocopos"
        rank:"species"
        sc:"leucotos"
        ja:"オオアカゲラ"
    }
    {
        "alien":false,
        upper:"dendrocopos"
        rank:"species"
        sc:"major"
        ja:"アカゲラ"
    }
    {
        "alien":false,
        upper:"picoides"
        rank:"species"
        sc:"tridactylus"
        ja:"ミユビゲラ"
    }
    {
        "alien":false,
        upper:"dryocopus"
        rank:"species"
        sc:"javensis"
        ja:"キタタキ"
    }
    {
        "alien":false,
        upper:"dryocopus"
        rank:"species"
        sc:"martius"
        ja:"クマゲラ"
    }
    {
        "alien":false,
        upper:"picus"
        rank:"species"
        sc:"awokera"
        ja:"アオゲラ"
    }
    {
        "alien":false,
        upper:"picus"
        rank:"species"
        sc:"canus"
        ja:"ヤマゲラ"
    }
    {
        "alien":false,
        upper:"sapheopipo"
        rank:"species"
        sc:"noguchii"
        ja:"ノグチゲラ"
    }
    {
        "alien":false,
        upper:"falco"
        rank:"species"
        sc:"naumanni"
        ja:"ヒメチョウゲンボウ"
    }
    {
        "alien":false,
        upper:"falco"
        rank:"species"
        sc:"tinnunculus"
        ja:"チョウゲンボウ"
    }
    {
        "alien":false,
        upper:"falco"
        rank:"species"
        sc:"amurensis"
        ja:"アカアシチョウゲンボウ"
    }
    {
        "alien":false,
        upper:"falco"
        rank:"species"
        sc:"columbarius"
        ja:"コチョウゲンボウ"
    }
    {
        "alien":false,
        upper:"falco"
        rank:"species"
        sc:"subbuteo"
        ja:"チゴハヤブサ"
    }
    {
        "alien":false,
        upper:"falco"
        rank:"species"
        sc:"cherrug"
        ja:"ワキスジハヤブサ"
    }
    {
        "alien":false,
        upper:"falco"
        rank:"species"
        sc:"rusticolus"
        ja:"シロハヤブサ"
    }
    {
        "alien":false,
        upper:"falco"
        rank:"species"
        sc:"peregrinus"
        ja:"ハヤブサ"
    }
    {
        "alien":false,
        upper:"pitta"
        rank:"species"
        sc:"sordida"
        ja:"ズグロヤイロチョウ"
    }
    {
        "alien":false,
        upper:"pitta"
        rank:"species"
        sc:"nympha"
        ja:"ヤイロチョウ"
    }
    {
        "alien":false,
        upper:"artamus"
        rank:"species"
        sc:"leucorynchus"
        ja:"モリツバメ"
    }
    {
        "alien":false,
        upper:"coracina"
        rank:"species"
        sc:"melaschistos"
        ja:"アサクラサンショウクイ"
    }
    {
        "alien":false,
        upper:"pericrocotus"
        rank:"species"
        sc:"divaricatus"
        ja:"サンショウクイ"
    }
    {
        "alien":false,
        upper:"oriolus"
        rank:"species"
        sc:"chinensis"
        ja:"コウライウグイス"
    }
    {
        "alien":false,
        upper:"dicrurus"
        rank:"species"
        sc:"macrocercus"
        ja:"オウチュウ"
    }
    {
        "alien":false,
        upper:"dicrurus"
        rank:"species"
        sc:"leucophaeus"
        ja:"ハイイロオウチュウ"
    }
    {
        "alien":false,
        upper:"dicrurus"
        rank:"species"
        sc:"hottentottus"
        ja:"カンムリオウチュウ"
    }
    {
        "alien":false,
        upper:"hypothymis"
        rank:"species"
        sc:"azurea"
        ja:"クロエリヒタキ"
    }
    {
        "alien":false,
        upper:"terpsiphone"
        rank:"species"
        sc:"atrocaudata"
        ja:"サンコウチョウ"
    }
    {
        "alien":false,
        upper:"lanius"
        rank:"species"
        sc:"tigrinus"
        ja:"チゴモズ"
    }
    {
        "alien":false,
        upper:"lanius"
        rank:"species"
        sc:"bucephalus"
        ja:"モズ"
    }
    {
        "alien":false,
        upper:"lanius"
        rank:"species"
        sc:"cristatus"
        ja:"アカモズ"
    }
    {
        "alien":false,
        upper:"lanius"
        rank:"species"
        sc:"collurio"
        ja:"セアカモズ"
    }
    {
        "alien":false,
        upper:"lanius"
        rank:"species"
        sc:"isabellinus"
        ja:"モウコアカモズ"
    }
    {
        "alien":false,
        upper:"lanius"
        rank:"species"
        sc:"schach"
        ja:"タカサゴモズ"
    }
    {
        "alien":false,
        upper:"lanius"
        rank:"species"
        sc:"excubitor"
        ja:"オオモズ"
    }
    {
        "alien":false,
        upper:"lanius"
        rank:"species"
        sc:"sphenocercus"
        ja:"オオカラモズ"
    }
    {
        "alien":false,
        upper:"garrulus"
        rank:"species"
        sc:"glandarius"
        ja:"カケス"
    }
    {
        "alien":false,
        upper:"garrulus"
        rank:"species"
        sc:"lidthi"
        ja:"ルリカケス"
    }
    {
        "alien":false,
        upper:"cyanopica"
        rank:"species"
        sc:"cyanus"
        ja:"オナガ"
    }
    {
        "alien":false,
        upper:"pica"
        rank:"species"
        sc:"pica"
        ja:"カササギ"
    }
    {
        "alien":false,
        upper:"nucifraga"
        rank:"species"
        sc:"caryocatactes"
        ja:"ホシガラス"
    }
    {
        "alien":false,
        upper:"corvus"
        rank:"species"
        sc:"monedula"
        ja:"ニシコクマルガラス"
    }
    {
        "alien":false,
        upper:"corvus"
        rank:"species"
        sc:"dauuricus"
        ja:"コクマルガラス"
    }
    {
        "alien":false,
        upper:"corvus"
        rank:"species"
        sc:"frugilegus"
        ja:"ミヤマガラス"
    }
    {
        "alien":false,
        upper:"corvus"
        rank:"species"
        sc:"corone"
        ja:"ハシボソガラス"
    }
    {
        "alien":false,
        upper:"corvus"
        rank:"species"
        sc:"macrorhynchos"
        ja:"ハシブトガラス"
    }
    {
        "alien":false,
        upper:"corvus"
        rank:"species"
        sc:"corax"
        ja:"ワタリガラス"
    }
    {
        "alien":false,
        upper:"regulus"
        rank:"species"
        sc:"regulus"
        ja:"キクイタダキ"
    }
    {
        "alien":false,
        upper:"remiz"
        rank:"species"
        sc:"pendulinus"
        ja:"ツリスガラ"
    }
    {
        "alien":false,
        upper:"poecile"
        rank:"species"
        sc:"palustris"
        ja:"ハシブトガラ"
    }
    {
        "alien":false,
        upper:"poecile"
        rank:"species"
        sc:"montanus"
        ja:"コガラ"
    }
    {
        "alien":false,
        upper:"poecile"
        rank:"species"
        sc:"varius"
        ja:"ヤマガラ"
    }
    {
        "alien":false,
        upper:"periparus"
        rank:"species"
        sc:"ater"
        ja:"ヒガラ"
    }
    {
        "alien":false,
        upper:"periparus"
        rank:"species"
        sc:"venustulus"
        ja:"キバラガラ"
    }
    {
        "alien":false,
        upper:"parus"
        rank:"species"
        sc:"minor"
        ja:"シジュウカラ"
    }
    {
        "alien":false,
        upper:"cyanistes"
        rank:"species"
        sc:"cyanus"
        ja:"ルリガラ"
    }
    {
        "alien":false,
        upper:"panurus"
        rank:"species"
        sc:"biarmicus"
        ja:"ヒゲガラ"
    }
    {
        "alien":false,
        upper:"melanocorypha"
        rank:"species"
        sc:"bimaculata"
        ja:"クビワコウテンシ"
    }
    {
        "alien":false,
        upper:"melanocorypha"
        rank:"species"
        sc:"mongolica"
        ja:"コウテンシ"
    }
    {
        "alien":false,
        upper:"calandrella"
        rank:"species"
        sc:"brachydactyla"
        ja:"ヒメコウテンシ"
    }
    {
        "alien":false,
        upper:"calandrella"
        rank:"species"
        sc:"cheleensis"
        ja:"コヒバリ"
    }
    {
        "alien":false,
        upper:"alauda"
        rank:"species"
        sc:"arvensis"
        ja:"ヒバリ"
    }
    {
        "alien":false,
        upper:"eremophila"
        rank:"species"
        sc:"alpestris"
        ja:"ハマヒバリ"
    }
    {
        "alien":false,
        upper:"riparia"
        rank:"species"
        sc:"paludicola"
        ja:"タイワンショウドウツバメ"
    }
    {
        "alien":false,
        upper:"riparia"
        rank:"species"
        sc:"riparia"
        ja:"ショウドウツバメ"
    }
    {
        "alien":false,
        upper:"tachycineta"
        rank:"species"
        sc:"bicolor"
        ja:"ミドリツバメ"
    }
    {
        "alien":false,
        upper:"hirundo"
        rank:"species"
        sc:"rustica"
        ja:"ツバメ"
    }
    {
        "alien":false,
        upper:"hirundo"
        rank:"species"
        sc:"tahitica"
        ja:"リュウキュウツバメ"
    }
    {
        "alien":false,
        upper:"hirundo"
        rank:"species"
        sc:"daurica"
        ja:"コシアカツバメ"
    }
    {
        "alien":false,
        upper:"delichon"
        rank:"species"
        sc:"urbicum"
        ja:"ニシイワツバメ"
    }
    {
        "alien":false,
        upper:"delichon"
        rank:"species"
        sc:"dasypus"
        ja:"イワツバメ"
    }
    {
        "alien":false,
        upper:"pycnonotus"
        rank:"species"
        sc:"sinensis"
        ja:"シロガシラ"
    }
    {
        "alien":false,
        upper:"hypsipetes"
        rank:"species"
        sc:"amaurotis"
        ja:"ヒヨドリ"
    }
    {
        "alien":false,
        upper:"cettia"
        rank:"species"
        sc:"diphone"
        ja:"ウグイス"
    }
    {
        "alien":false,
        upper:"urosphena"
        rank:"species"
        sc:"squameiceps"
        ja:"ヤブサメ"
    }
    {
        "alien":false,
        upper:"aegithalos"
        rank:"species"
        sc:"caudatus"
        ja:"エナガ"
    }
    {
        "alien":false,
        upper:"phylloscopus"
        rank:"species"
        sc:"trochilus"
        ja:"キタヤナギムシクイ"
    }
    {
        "alien":false,
        upper:"phylloscopus"
        rank:"species"
        sc:"collybita"
        ja:"チフチャフ"
    }
    {
        "alien":false,
        upper:"phylloscopus"
        rank:"species"
        sc:"sibilatrix"
        ja:"モリムシクイ"
    }
    {
        "alien":false,
        upper:"phylloscopus"
        rank:"species"
        sc:"fuscatus"
        ja:"ムジセッカ"
    }
    {
        "alien":false,
        upper:"phylloscopus"
        rank:"species"
        sc:"affinis"
        ja:"キバラムシクイ"
    }
    {
        "alien":false,
        upper:"phylloscopus"
        rank:"species"
        sc:"schwarzi"
        ja:"カラフトムジセッカ"
    }
    {
        "alien":false,
        upper:"phylloscopus"
        rank:"species"
        sc:"proregulus"
        ja:"カラフトムシクイ"
    }
    {
        "alien":false,
        upper:"phylloscopus"
        rank:"species"
        sc:"inornatus"
        ja:"キマユムシクイ"
    }
    {
        "alien":false,
        upper:"phylloscopus"
        rank:"species"
        sc:"borealis"
        ja:"コムシクイ"
    }
    {
        "alien":false,
        upper:"phylloscopus"
        rank:"species"
        sc:"examinandus"
        ja:"オオムシクイ"
    }
    {
        "alien":false,
        upper:"phylloscopus"
        rank:"species"
        sc:"xanthodryas"
        ja:"メボソムシクイ"
    }
    {
        "alien":false,
        upper:"phylloscopus"
        rank:"species"
        sc:"plumbeitarsus"
        ja:"ヤナギムシクイ"
    }
    {
        "alien":false,
        upper:"phylloscopus"
        rank:"species"
        sc:"borealoides"
        ja:"エゾムシクイ"
    }
    {
        "alien":false,
        upper:"phylloscopus"
        rank:"species"
        sc:"coronatus"
        ja:"センダイムシクイ"
    }
    {
        "alien":false,
        upper:"phylloscopus"
        rank:"species"
        sc:"ijimae"
        ja:"イイジマムシクイ"
    }
    {
        "alien":false,
        upper:"sylvia"
        rank:"species"
        sc:"curruca"
        ja:"コノドジロムシクイ"
    }
    {
        "alien":false,
        upper:"apalopteron"
        rank:"species"
        sc:"familiare"
        ja:"メグロ"
    }
    {
        "alien":false,
        upper:"zosterops"
        rank:"species"
        sc:"erythropleurus"
        ja:"チョウセンメジロ"
    }
    {
        "alien":false,
        upper:"zosterops"
        rank:"species"
        sc:"japonicus"
        ja:"メジロ"
    }
    {
        "alien":false,
        upper:"locustella"
        rank:"species"
        sc:"lanceolata"
        ja:"マキノセンニュウ"
    }
    {
        "alien":false,
        upper:"locustella"
        rank:"species"
        sc:"ochotensis"
        ja:"シマセンニュウ"
    }
    {
        "alien":false,
        upper:"locustella"
        rank:"species"
        sc:"pleskei"
        ja:"ウチヤマセンニュウ"
    }
    {
        "alien":false,
        upper:"locustella"
        rank:"species"
        sc:"certhiola"
        ja:"シベリアセンニュウ"
    }
    {
        "alien":false,
        upper:"locustella"
        rank:"species"
        sc:"pryeri"
        ja:"オオセッカ"
    }
    {
        "alien":false,
        upper:"locustella"
        rank:"species"
        sc:"fasciolata"
        ja:"エゾセンニュウ"
    }
    {
        "alien":false,
        upper:"acrocephalus"
        rank:"species"
        sc:"orientalis"
        ja:"オオヨシキリ"
    }
    {
        "alien":false,
        upper:"acrocephalus"
        rank:"species"
        sc:"bistrigiceps"
        ja:"コヨシキリ"
    }
    {
        "alien":false,
        upper:"acrocephalus"
        rank:"species"
        sc:"sorghophilus"
        ja:"セスジコヨシキリ"
    }
    {
        "alien":false,
        upper:"acrocephalus"
        rank:"species"
        sc:"agricola"
        ja:"イナダヨシキリ"
    }
    {
        "alien":false,
        upper:"acrocephalus"
        rank:"species"
        sc:"dumetorum"
        ja:"ヤブヨシキリ"
    }
    {
        "alien":false,
        upper:"acrocephalus"
        rank:"species"
        sc:"aedon"
        ja:"ハシブトオオヨシキリ"
    }
    {
        "alien":false,
        upper:"iduna"
        rank:"species"
        sc:"caligata"
        ja:"ヒメウタイムシクイ"
    }
    {
        "alien":false,
        upper:"cisticola"
        rank:"species"
        sc:"juncidis"
        ja:"セッカ"
    }
    {
        "alien":false,
        upper:"bombycilla"
        rank:"species"
        sc:"garrulus"
        ja:"キレンジャク"
    }
    {
        "alien":false,
        upper:"bombycilla"
        rank:"species"
        sc:"japonica"
        ja:"ヒレンジャク"
    }
    {
        "alien":false,
        upper:"sitta"
        rank:"species"
        sc:"europaea"
        ja:"ゴジュウカラ"
    }
    {
        "alien":false,
        upper:"certhia"
        rank:"species"
        sc:"familiaris"
        ja:"キバシリ"
    }
    {
        "alien":false,
        upper:"troglodytes"
        rank:"species"
        sc:"troglodytes"
        ja:"ミソサザイ"
    }
    {
        "alien":false,
        upper:"spodiopsar"
        rank:"species"
        sc:"sericeus"
        ja:"ギンムクドリ"
    }
    {
        "alien":false,
        upper:"spodiopsar"
        rank:"species"
        sc:"cineraceus"
        ja:"ムクドリ"
    }
    {
        "alien":false,
        upper:"agropsar"
        rank:"species"
        sc:"sturninus"
        ja:"シベリアムクドリ"
    }
    {
        "alien":false,
        upper:"agropsar"
        rank:"species"
        sc:"philippensis"
        ja:"コムクドリ"
    }
    {
        "alien":false,
        upper:"sturnia"
        rank:"species"
        sc:"sinensis"
        ja:"カラムクドリ"
    }
    {
        "alien":false,
        upper:"pastor"
        rank:"species"
        sc:"roseus"
        ja:"バライロムクドリ"
    }
    {
        "alien":false,
        upper:"sturnus"
        rank:"species"
        sc:"vulgaris"
        ja:"ホシムクドリ"
    }
    {
        "alien":false,
        upper:"cinclus"
        rank:"species"
        sc:"pallasii"
        ja:"カワガラス"
    }
    {
        "alien":false,
        upper:"zoothera"
        rank:"species"
        sc:"sibirica"
        ja:"マミジロ"
    }
    {
        "alien":false,
        upper:"zoothera"
        rank:"species"
        sc:"dauma"
        ja:"トラツグミ"
    }
    {
        "alien":false,
        upper:"cichlopasser"
        rank:"species"
        sc:"terrestris"
        ja:"オガサワラガビチョウ"
    }
    {
        "alien":false,
        upper:"catharus"
        rank:"species"
        sc:"minimus"
        ja:"ハイイロチャツグミ"
    }
    {
        "alien":false,
        upper:"turdus"
        rank:"species"
        sc:"hortulorum"
        ja:"カラアカハラ"
    }
    {
        "alien":false,
        upper:"turdus"
        rank:"species"
        sc:"cardis"
        ja:"クロツグミ"
    }
    {
        "alien":false,
        upper:"turdus"
        rank:"species"
        sc:"merula"
        ja:"クロウタドリ"
    }
    {
        "alien":false,
        upper:"turdus"
        rank:"species"
        sc:"obscurus"
        ja:"マミチャジナイ"
    }
    {
        "alien":false,
        upper:"turdus"
        rank:"species"
        sc:"pallidus"
        ja:"シロハラ"
    }
    {
        "alien":false,
        upper:"turdus"
        rank:"species"
        sc:"chrysolaus"
        ja:"アカハラ"
    }
    {
        "alien":false,
        upper:"turdus"
        rank:"species"
        sc:"celaenops"
        ja:"アカコッコ"
    }
    {
        "alien":false,
        upper:"turdus"
        rank:"species"
        sc:"ruficollis"
        ja:"ノドグロツグミ"
    }
    {
        "alien":false,
        upper:"turdus"
        rank:"species"
        sc:"naumanni"
        ja:"ツグミ"
    }
    {
        "alien":false,
        upper:"turdus"
        rank:"species"
        sc:"pilaris"
        ja:"ノハラツグミ"
    }
    {
        "alien":false,
        upper:"turdus"
        rank:"species"
        sc:"iliacus"
        ja:"ワキアカツグミ"
    }
    {
        "alien":false,
        upper:"turdus"
        rank:"species"
        sc:"viscivorus"
        ja:"ヤドリギツグミ"
    }
    {
        "alien":false,
        upper:"erithacus"
        rank:"species"
        sc:"rubecula"
        ja:"ヨーロッパコマドリ"
    }
    {
        "alien":false,
        upper:"luscinia"
        rank:"species"
        sc:"akahige"
        ja:"コマドリ"
    }
    {
        "alien":false,
        upper:"luscinia"
        rank:"species"
        sc:"komadori"
        ja:"アカヒゲ"
    }
    {
        "alien":false,
        upper:"luscinia"
        rank:"species"
        sc:"svecica"
        ja:"オガワコマドリ"
    }
    {
        "alien":false,
        upper:"luscinia"
        rank:"species"
        sc:"calliope"
        ja:"ノゴマ"
    }
    {
        "alien":false,
        upper:"luscinia"
        rank:"species"
        sc:"cyane"
        ja:"コルリ"
    }
    {
        "alien":false,
        upper:"luscinia"
        rank:"species"
        sc:"sibilans"
        ja:"シマゴマ"
    }
    {
        "alien":false,
        upper:"tarsiger"
        rank:"species"
        sc:"cyanurus"
        ja:"ルリビタキ"
    }
    {
        "alien":false,
        upper:"phoenicurus"
        rank:"species"
        sc:"erythronotus"
        ja:"セアカジョウビタキ"
    }
    {
        "alien":false,
        upper:"phoenicurus"
        rank:"species"
        sc:"ochruros"
        ja:"クロジョウビタキ"
    }
    {
        "alien":false,
        upper:"phoenicurus"
        rank:"species"
        sc:"phoenicurus"
        ja:"シロビタイジョウビタキ"
    }
    {
        "alien":false,
        upper:"phoenicurus"
        rank:"species"
        sc:"auroreus"
        ja:"ジョウビタキ"
    }
    {
        "alien":false,
        upper:"saxicola"
        rank:"species"
        sc:"rubetra"
        ja:"マミジロノビタキ"
    }
    {
        "alien":false,
        upper:"saxicola"
        rank:"species"
        sc:"torquatus"
        ja:"ノビタキ"
    }
    {
        "alien":false,
        upper:"saxicola"
        rank:"species"
        sc:"caprata"
        ja:"クロノビタキ"
    }
    {
        "alien":false,
        upper:"saxicola"
        rank:"species"
        sc:"ferreus"
        ja:"ヤマザキヒタキ"
    }
    {
        "alien":false,
        upper:"oenanthe"
        rank:"species"
        sc:"isabellina"
        ja:"イナバヒタキ"
    }
    {
        "alien":false,
        upper:"oenanthe"
        rank:"species"
        sc:"oenanthe"
        ja:"ハシグロヒタキ"
    }
    {
        "alien":false,
        upper:"oenanthe"
        rank:"species"
        sc:"pleschanka"
        ja:"セグロサバクヒタキ"
    }
    {
        "alien":false,
        upper:"oenanthe"
        rank:"species"
        sc:"deserti"
        ja:"サバクヒタキ"
    }
    {
        "alien":false,
        upper:"monticola"
        rank:"species"
        sc:"solitarius"
        ja:"イソヒヨドリ"
    }
    {
        "alien":false,
        upper:"monticola"
        rank:"species"
        sc:"gularis"
        ja:"ヒメイソヒヨ"
    }
    {
        "alien":false,
        upper:"muscicapa"
        rank:"species"
        sc:"striata"
        ja:"ムナフヒタキ"
    }
    {
        "alien":false,
        upper:"muscicapa"
        rank:"species"
        sc:"griseisticta"
        ja:"エゾビタキ"
    }
    {
        "alien":false,
        upper:"muscicapa"
        rank:"species"
        sc:"sibirica"
        ja:"サメビタキ"
    }
    {
        "alien":false,
        upper:"muscicapa"
        rank:"species"
        sc:"dauurica"
        ja:"コサメビタキ"
    }
    {
        "alien":false,
        upper:"muscicapa"
        rank:"species"
        sc:"ferruginea"
        ja:"ミヤマヒタキ"
    }
    {
        "alien":false,
        upper:"ficedula"
        rank:"species"
        sc:"hypoleuca"
        ja:"マダラヒタキ"
    }
    {
        "alien":false,
        upper:"ficedula"
        rank:"species"
        sc:"zanthopygia"
        ja:"マミジロキビタキ"
    }
    {
        "alien":false,
        upper:"ficedula"
        rank:"species"
        sc:"narcissina"
        ja:"キビタキ"
    }
    {
        "alien":false,
        upper:"ficedula"
        rank:"species"
        sc:"mugimaki"
        ja:"ムギマキ"
    }
    {
        "alien":false,
        upper:"ficedula"
        rank:"species"
        sc:"albicilla"
        ja:"オジロビタキ"
    }
    {
        "alien":false,
        upper:"cyanoptila"
        rank:"species"
        sc:"cyanomelana"
        ja:"オオルリ"
    }
    {
        "alien":false,
        upper:"eumyias"
        rank:"species"
        sc:"thalassinus"
        ja:"ロクショウヒタキ"
    }
    {
        "alien":false,
        upper:"niltava"
        rank:"species"
        sc:"vivida"
        ja:"チャバラオオルリ"
    }
    {
        "alien":false,
        upper:"prunella"
        rank:"species"
        sc:"collaris"
        ja:"イワヒバリ"
    }
    {
        "alien":false,
        upper:"prunella"
        rank:"species"
        sc:"montanella"
        ja:"ヤマヒバリ"
    }
    {
        "alien":false,
        upper:"prunella"
        rank:"species"
        sc:"rubida"
        ja:"カヤクグリ"
    }
    {
        "alien":false,
        upper:"passer"
        rank:"species"
        sc:"domesticus"
        ja:"イエスズメ"
    }
    {
        "alien":false,
        upper:"passer"
        rank:"species"
        sc:"rutilans"
        ja:"ニュウナイスズメ"
    }
    {
        "alien":false,
        upper:"passer"
        rank:"species"
        sc:"montanus"
        ja:"スズメ"
    }
    {
        "alien":false,
        upper:"dendronanthus"
        rank:"species"
        sc:"indicus"
        ja:"イワミセキレイ"
    }
    {
        "alien":false,
        upper:"motacilla"
        rank:"species"
        sc:"flava"
        ja:"ツメナガセキレイ"
    }
    {
        "alien":false,
        upper:"motacilla"
        rank:"species"
        sc:"citreola"
        ja:"キガシラセキレイ"
    }
    {
        "alien":false,
        upper:"motacilla"
        rank:"species"
        sc:"cinerea"
        ja:"キセキレイ"
    }
    {
        "alien":false,
        upper:"motacilla"
        rank:"species"
        sc:"alba"
        ja:"ハクセキレイ"
    }
    {
        "alien":false,
        upper:"motacilla"
        rank:"species"
        sc:"grandis"
        ja:"セグロセキレイ"
    }
    {
        "alien":false,
        upper:"anthus"
        rank:"species"
        sc:"richardi"
        ja:"マミジロタヒバリ"
    }
    {
        "alien":false,
        upper:"anthus"
        rank:"species"
        sc:"godlewskii"
        ja:"コマミジロタヒバリ"
    }
    {
        "alien":false,
        upper:"anthus"
        rank:"species"
        sc:"pratensis"
        ja:"マキバタヒバリ"
    }
    {
        "alien":false,
        upper:"anthus"
        rank:"species"
        sc:"trivialis"
        ja:"ヨーロッパビンズイ"
    }
    {
        "alien":false,
        upper:"anthus"
        rank:"species"
        sc:"hodgsoni"
        ja:"ビンズイ"
    }
    {
        "alien":false,
        upper:"anthus"
        rank:"species"
        sc:"gustavi"
        ja:"セジロタヒバリ"
    }
    {
        "alien":false,
        upper:"anthus"
        rank:"species"
        sc:"roseatus"
        ja:"ウスベニタヒバリ"
    }
    {
        "alien":false,
        upper:"anthus"
        rank:"species"
        sc:"cervinus"
        ja:"ムネアカタヒバリ"
    }
    {
        "alien":false,
        upper:"anthus"
        rank:"species"
        sc:"rubescens"
        ja:"タヒバリ"
    }
    {
        "alien":false,
        upper:"fringilla"
        rank:"species"
        sc:"coelebs"
        ja:"ズアオアトリ"
    }
    {
        "alien":false,
        upper:"fringilla"
        rank:"species"
        sc:"montifringilla"
        ja:"アトリ"
    }
    {
        "alien":false,
        upper:"chloris"
        rank:"species"
        sc:"sinica"
        ja:"カワラヒワ"
    }
    {
        "alien":false,
        upper:"carduelis"
        rank:"species"
        sc:"spinus"
        ja:"マヒワ"
    }
    {
        "alien":false,
        upper:"carduelis"
        rank:"species"
        sc:"flammea"
        ja:"ベニヒワ"
    }
    {
        "alien":false,
        upper:"carduelis"
        rank:"species"
        sc:"hornemanni"
        ja:"コベニヒワ"
    }
    {
        "alien":false,
        upper:"leucosticte"
        rank:"species"
        sc:"arctoa"
        ja:"ハギマシコ"
    }
    {
        "alien":false,
        upper:"uragus"
        rank:"species"
        sc:"sibiricus"
        ja:"ベニマシコ"
    }
    {
        "alien":false,
        upper:"chaunoproctus"
        rank:"species"
        sc:"ferreorostris"
        ja:"オガサワラマシコ"
    }
    {
        "alien":false,
        upper:"carpodacus"
        rank:"species"
        sc:"erythrinus"
        ja:"アカマシコ"
    }
    {
        "alien":false,
        upper:"carpodacus"
        rank:"species"
        sc:"roseus"
        ja:"オオマシコ"
    }
    {
        "alien":false,
        upper:"pinicola"
        rank:"species"
        sc:"enucleator"
        ja:"ギンザンマシコ"
    }
    {
        "alien":false,
        upper:"loxia"
        rank:"species"
        sc:"curvirostra"
        ja:"イスカ"
    }
    {
        "alien":false,
        upper:"loxia"
        rank:"species"
        sc:"leucoptera"
        ja:"ナキイスカ"
    }
    {
        "alien":false,
        upper:"pyrrhula"
        rank:"species"
        sc:"pyrrhula"
        ja:"ウソ"
    }
    {
        "alien":false,
        upper:"coccothraustes"
        rank:"species"
        sc:"coccothraustes"
        ja:"シメ"
    }
    {
        "alien":false,
        upper:"eophona"
        rank:"species"
        sc:"migratoria"
        ja:"コイカル"
    }
    {
        "alien":false,
        upper:"eophona"
        rank:"species"
        sc:"personata"
        ja:"イカル"
    }
    {
        "alien":false,
        upper:"calcarius"
        rank:"species"
        sc:"lapponicus"
        ja:"ツメナガホオジロ"
    }
    {
        "alien":false,
        upper:"plectrophenax"
        rank:"species"
        sc:"nivalis"
        ja:"ユキホオジロ"
    }
    {
        "alien":false,
        upper:"setophaga"
        rank:"species"
        sc:"coronata"
        ja:"キヅタアメリカムシクイ"
    }
    {
        "alien":false,
        upper:"cardellina"
        rank:"species"
        sc:"pusilla"
        ja:"ウィルソンアメリカムシクイ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"lathami"
        ja:"レンジャクノジコ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"citrinella"
        ja:"キアオジ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"leucocephalos"
        ja:"シラガホオジロ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"cioides"
        ja:"ホオジロ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"buchanani"
        ja:"イワバホオジロ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"hortulana"
        ja:"ズアオホオジロ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"tristrami"
        ja:"シロハラホオジロ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"fucata"
        ja:"ホオアカ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"pusilla"
        ja:"コホオアカ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"chrysophrys"
        ja:"キマユホオジロ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"rustica"
        ja:"カシラダカ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"elegans"
        ja:"ミヤマホオジロ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"aureola"
        ja:"シマアオジ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"rutila"
        ja:"シマノジコ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"melanocephala"
        ja:"ズグロチャキンチョウ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"bruniceps"
        ja:"チャキンチョウ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"sulphurata"
        ja:"ノジコ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"spodocephala"
        ja:"アオジ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"variabilis"
        ja:"クロジ"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"pallasi"
        ja:"シベリアジュリン"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"yessoensis"
        ja:"コジュリン"
    }
    {
        "alien":false,
        upper:"emberiza"
        rank:"species"
        sc:"schoeniclus"
        ja:"オオジュリン"
    }
    {
        "alien":false,
        upper:"passerella"
        rank:"species"
        sc:"iliaca"
        ja:"ゴマフスズメ"
    }
    {
        "alien":false,
        upper:"melospiza"
        rank:"species"
        sc:"melodia"
        ja:"ウタスズメ"
    }
    {
        "alien":false,
        upper:"zonotrichia"
        rank:"species"
        sc:"leucophrys"
        ja:"ミヤマシトド"
    }
    {
        "alien":false,
        upper:"zonotrichia"
        rank:"species"
        sc:"atricapilla"
        ja:"キガシラシトド"
    }
    {
        "alien":false,
        upper:"passerculus"
        rank:"species"
        sc:"sandwichensis"
        ja:"サバンナシトド"
    }
    {
        "alien":true,
        upper:"bambusicola"
        rank:"species"
        sc:"thoracicus"
        ja:"コジュケイ"
    }
    {
        "alien":true,
        upper:"syrmaticus"
        rank:"species"
        sc:"soemmerringii"
        ja:"ヤマドリ"
    }
    {
        "alien":true,
        upper:"phasianus"
        rank:"species"
        sc:"colchicus"
        ja:"キジ"
    }
    {
        "alien":true,
        upper:"pavo"
        rank:"species"
        sc:"cristatus"
        ja:"インドクジャク"
    }
    {
        "alien":true,
        upper:"branta"
        rank:"species"
        sc:"canadensis"
        ja:"カナダガン"
    }
    {
        "alien":true,
        upper:"cygnus"
        rank:"species"
        sc:"atratus"
        ja:"コクチョウ"
    }
    {
        "alien":true,
        upper:"cygnus"
        rank:"species"
        sc:"olor"
        ja:"コブハクチョウ"
    }
    {
        "alien":true,
        upper:"columba"
        rank:"species"
        sc:"livia"
        ja:"カワラバト(ドバト)"
    }
    {
        "alien":true,
        upper:"streptopelia"
        rank:"species"
        sc:"decaocto"
        ja:"シラコバト"
    }
    {
        "alien":true,
        upper:"ciconia"
        rank:"species"
        sc:"boyciana"
        ja:"コウノトリ"
    }
    {
        "alien":true,
        upper:"nipponia"
        rank:"species"
        sc:"nippon"
        ja:"トキ"
    }
    {
        "alien":true,
        upper:"himantopus"
        rank:"species"
        sc:"himantopus"
        ja:"セイタカシギ"
    }
    {
        "alien":true,
        upper:"melopsittacus"
        rank:"species"
        sc:"undulatus"
        ja:"セキセイインコ"
    }
    {
        "alien":true,
        upper:"psittacula"
        rank:"species"
        sc:"eupatria"
        ja:"オオホンセイインコ"
    }
    {
        "alien":true,
        upper:"psittacula"
        rank:"species"
        sc:"krameri"
        ja:"ホンセイインコ"
    }
    {
        "alien":true,
        upper:"psittacula"
        rank:"species"
        sc:"alexandri"
        ja:"ダルマインコ"
    }
    {
        "alien":true,
        upper:"myiopsitta"
        rank:"species"
        sc:"monachus"
        ja:"オキナインコ"
    }
    {
        "alien":true,
        upper:"urocissa"
        rank:"species"
        sc:"caerulea"
        ja:"ヤマムスメ"
    }
    {
        "alien":true,
        upper:"pica"
        rank:"species"
        sc:"pica"
        ja:"カササギ"
    }
    {
        "alien":true,
        upper:"zosterops"
        rank:"species"
        sc:"japonicus"
        ja:"メジロ"
    }
    {
        "alien":true,
        upper:"garrulax"
        rank:"species"
        sc:"canorus"
        ja:"ガビチョウ"
    }
    {
        "alien":true,
        upper:"garrulax"
        rank:"species"
        sc:"cineraceus"
        ja:"ヒゲガビチョウ"
    }
    {
        "alien":true,
        upper:"garrulax"
        rank:"species"
        sc:"perspicillatus"
        ja:"カオグロガビチョウ"
    }
    {
        "alien":true,
        upper:"garrulax"
        rank:"species"
        sc:"sannio"
        ja:"カオジロガビチョウ"
    }
    {
        "alien":true,
        upper:"leiothrix"
        rank:"species"
        sc:"lutea"
        ja:"ソウシチョウ"
    }
    {
        "alien":true,
        upper:"acridotheres"
        rank:"species"
        sc:"cristatellus"
        ja:"ハッカチョウ"
    }
    {
        "alien":true,
        upper:"acridotheres"
        rank:"species"
        sc:"javanicus"
        ja:"モリハッカ"
    }
    {
        "alien":true,
        upper:"acridotheres"
        rank:"species"
        sc:"ginginianus"
        ja:"ハイイロハッカ"
    }
    {
        "alien":true,
        upper:"acridotheres"
        rank:"species"
        sc:"tristis"
        ja:"インドハッカ"
    }
    {
        "alien":true,
        upper:"gracupica"
        rank:"species"
        sc:"contra"
        ja:"ホオジロムクドリ"
    }
    {
        "alien":true,
        upper:"ploceus"
        rank:"species"
        sc:"intermedius"
        ja:"メンハタオリドリ"
    }
    {
        "alien":true,
        upper:"euplectes"
        rank:"species"
        sc:"orix"
        ja:"オオキンランチョウ"
    }
    {
        "alien":true,
        upper:"estrilda"
        rank:"species"
        sc:"melpoda"
        ja:"ホオアカカエデチョウ"
    }
    {
        "alien":true,
        upper:"estrilda"
        rank:"species"
        sc:"troglodytes"
        ja:"カエデチョウ"
    }
    {
        "alien":true,
        upper:"amandava"
        rank:"species"
        sc:"amandava"
        ja:"ベニスズメ"
    }
    {
        "alien":true,
        upper:"lonchura"
        rank:"species"
        sc:"striata"
        ja:"コシジロキンパラ"
    }
    {
        "alien":true,
        upper:"lonchura"
        rank:"species"
        sc:"punctulata"
        ja:"シマキンパラ"
    }
    {
        "alien":true,
        upper:"lonchura"
        rank:"species"
        sc:"malacca"
        ja:"ギンパラ"
    }
    {
        "alien":true,
        upper:"lonchura"
        rank:"species"
        sc:"atricapilla"
        ja:"キンパラ"
    }
    {
        "alien":true,
        upper:"lonchura"
        rank:"species"
        sc:"maja"
        ja:"ヘキチョウ"
    }
    {
        "alien":true,
        upper:"lonchura"
        rank:"species"
        sc:"oryzivora"
        ja:"ブンチョウ"
    }
    {
        "alien":true,
        upper:"vidua"
        rank:"species"
        sc:"paradisaea"
        ja:"ホウオウジャク"
    }
    {
        "alien":true,
        upper:"paroaria"
        rank:"species"
        sc:"coronata"
        ja:"コウカンチョウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"bonasia"
        sc:"vicinitas"
        ja:"エゾライチョウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"muta"
        sc:"japonica"
        ja:"ライチョウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"soemmerringii"
        sc:"scintillans"
        ja:"ヤマドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"soemmerringii"
        sc:"subrufus"
        ja:"ウスアカヤマドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"soemmerringii"
        sc:"intermedius"
        ja:"シコクヤマドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"soemmerringii"
        sc:"soemmerringii"
        ja:"アカヤマドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"soemmerringii"
        sc:"ijimae"
        ja:"コシジロヤマドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"colchicus"
        sc:"robustipes"
        ja:"キジ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"colchicus"
        sc:"tohkaidi"
        ja:"トウカイキジ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"colchicus"
        sc:"tanensis"
        ja:"シマキジ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"colchicus"
        sc:"versicolor"
        ja:"キュウシュウキジ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"fabalis"
        sc:"middendorffii"
        ja:"オオヒシクイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"fabalis"
        sc:"curtus"
        ja:"ヒメヒシクイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"fabalis"
        sc:"serrirostris"
        ja:"ヒシクイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"anser"
        sc:"rubrirostris"
        ja:"ハイイロガン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"albifrons"
        sc:"albifrons"
        ja:"マガン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"caerulescens"
        sc:"caerulescens"
        ja:"ハクガン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"caerulescens"
        sc:"atlanticus"
        ja:"オオハクガン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"hutchinsii"
        sc:"leucopareia"
        ja:"シジュウカラガン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"hutchinsii"
        sc:"minima"
        ja:"ヒメシジュウカラガン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"bernicla"
        sc:"orientalis"
        ja:"コクガン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"columbianus"
        sc:"jankowskyi"
        ja:"コハクチョウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"columbianus"
        sc:"columbianus"
        ja:"アメリカコハクチョウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"coromandelianus"
        sc:"coromandelianus"
        ja:"ナンキンオシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"strepera"
        sc:"strepera"
        ja:"オカヨシガモ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"platyrhynchos"
        sc:"platyrhynchos"
        ja:"マガモ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"crecca"
        sc:"crecca"
        ja:"コガモ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"crecca"
        sc:"carolinensis"
        ja:"アメリカコガモ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"marila"
        sc:"marila"
        ja:"スズガモ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"fusca"
        sc:"stejnegeri"
        ja:"ビロードキンクロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"clangula"
        sc:"clangula"
        ja:"ホオジロガモ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"merganser"
        sc:"merganser"
        ja:"カワアイサ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"merganser"
        sc:"orientalis"
        ja:"コカワアイサ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"ruficollis"
        sc:"poggei"
        ja:"カイツブリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"ruficollis"
        sc:"kunikyonis"
        ja:"ダイトウカイツブリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"grisegena"
        sc:"holbollii"
        ja:"アカエリカイツブリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cristatus"
        sc:"cristatus"
        ja:"カンムリカイツブリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"auritus"
        sc:"auritus"
        ja:"ミミカイツブリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"nigricollis"
        sc:"nigricollis"
        ja:"ハジロカイツブリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"rubricauda"
        sc:"rothschildi"
        ja:"アカオネッタイチョウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"lepturus"
        sc:"dorotheae"
        ja:"シラオネッタイチョウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"oenas"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"janthina"
        sc:"janthina"
        ja:"カラスバト"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"janthina"
        sc:"nitens"
        ja:"アカガシラカラスバト"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"janthina"
        sc:"stejnegeri"
        ja:"ヨナグニカラスバト"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"orientalis"
        sc:"orientalis"
        ja:"キジバト"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"orientalis"
        sc:"stimpsoni"
        ja:"リュウキュウキジバト"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"decaocto"
        sc:"decaocto"
        ja:"シラコバト"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"tranquebarica"
        sc:"humilis"
        ja:"ベニバト"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"indica"
        sc:"yamashinai"
        ja:"キンバト"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sieboldii"
        sc:"sieboldii"
        ja:"アオバト"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"formosae"
        sc:"permagnus"
        ja:"ズアカアオバト"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"formosae"
        sc:"medioximus"
        ja:"チュウダイズアカアオバト"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leclancheri"
        sc:"taiwanus"
        ja:"クロアゴヒメアオバト"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"arctica"
        sc:"viridigularis"
        ja:"オオハム"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"glacialis"
        sc:"rodgersii"
        ja:"フルマカモメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"phaeopygia"
        sc:"sandwichensis"
        ja:"ハワイシロハラミズナギドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pacificus"
        sc:"cuneatus"
        ja:"オナガミズナギドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"lherminieri"
        sc:"bannermani"
        ja:"セグロミズナギドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"oceanicus"
        sc:"exasperatus"
        ja:"アシナガウミツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leucorhoa"
        sc:"leucorhoa"
        ja:"コシジロウミツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"furcata"
        sc:"furcata"
        ja:"ハイイロウミツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"minor"
        sc:"minor"
        ja:"オオグンカンドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"ariel"
        sc:"ariel"
        ja:"コグンカンドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"dactylatra"
        sc:"personata"
        ja:"アオツラカツオドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sula"
        sc:"rubripes"
        ja:"アカアシカツオドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leucogaster"
        sc:"plotus"
        ja:"カツオドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leucogaster"
        sc:"brewsteri"
        ja:"シロガシラカツオドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pelagicus"
        sc:"pelagicus"
        ja:"ヒメウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"carbo"
        sc:"hanedae"
        ja:"カワウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"stellaris"
        sc:"stellaris"
        ja:"サンカノゴイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sinensis"
        sc:"sinensis"
        ja:"ヨシゴイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sinensis"
        sc:"bryani"
        ja:"マリアナヨシゴイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"flavicollis"
        sc:"flavicollis"
        ja:"タカサゴクロサギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"nycticorax"
        sc:"nycticorax"
        ja:"ゴイサギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"caledonicus"
        sc:"crassirostris"
        ja:"ハシブトゴイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"striata"
        sc:"amurensis"
        ja:"ササゴイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"ibis"
        sc:"coromandus"
        ja:"アマサギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cinerea"
        sc:"jouyi"
        ja:"アオサギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"purpurea"
        sc:"manilensis"
        ja:"ムラサキサギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alba"
        sc:"alba"
        ja:"ダイサギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alba"
        sc:"modesta"
        ja:"チュウダイサギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"intermedia"
        sc:"intermedia"
        ja:"チュウサギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"garzetta"
        sc:"garzetta"
        ja:"コサギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sacra"
        sc:"sacra"
        ja:"クロサギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leucorodia"
        sc:"leucorodia"
        ja:"ヘラサギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"canadensis"
        sc:"canadensis"
        ja:"カナダヅル"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"grus"
        sc:"lilfordi"
        ja:"クロヅル"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"eurizonoides"
        sc:"sepiaria"
        ja:"オオクイナ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"striatus"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"aquaticus"
        sc:"indicus"
        ja:"クイナ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"phoenicurus"
        sc:"phoenicurus"
        ja:"シロハラクイナ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pusilla"
        sc:"pusilla"
        ja:"ヒメクイナ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"fusca"
        sc:"erythrothorax"
        ja:"ヒクイナ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"fusca"
        sc:"phaeopyga"
        ja:"リュウキュウヒクイナ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cinerea"
        sc:"brevipes"
        ja:"マミジロクイナ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"chloropus"
        sc:"chloropus"
        ja:"バン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"atra"
        sc:"atra"
        ja:"オオバン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"tarda"
        sc:"dybowskii"
        ja:"ノガン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"bengalensis"
        sc:"lignator"
        ja:"バンケン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"scolopaceus"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"lugubris"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"micropterus"
        sc:"micropterus"
        ja:"セグロカッコウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"canorus"
        sc:"telephonus"
        ja:"カッコウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"indicus"
        sc:"jotaka"
        ja:"ヨタカ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"brevirostris"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"caudacutus"
        sc:"caudacutus"
        ja:"ハリオアマツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pacificus"
        sc:"pacificus"
        ja:"キタアマツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pacificus"
        sc:"kurodae"
        ja:"アマツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"nipalensis"
        sc:"kuntzi"
        ja:"ヒメアマツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"apricaria"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"hiaticula"
        sc:"tundrae"
        ja:"ハジロコチドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"dubius"
        sc:"curonicus"
        ja:"コチドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alexandrinus"
        sc:"alexandrinus"
        ja:"ハシボソシロチドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alexandrinus"
        sc:"dealbatus"
        ja:"シロチドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"mongolus"
        sc:"mongolus"
        ja:"モウコメダイチドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"mongolus"
        sc:"stegmanni"
        ja:"メダイチドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"ostralegus"
        sc:"osculans"
        ja:"ミヤコドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"himantopus"
        sc:"himantopus"
        ja:"セイタカシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"himantopus"
        sc:"leucocephalus"
        ja:"オーストラリアセイタカシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"solitaria"
        sc:"japonica"
        ja:"アオシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"gallinago"
        sc:"gallinago"
        ja:"タシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"griseus"
        sc:"hendersoni"
        ja:"アメリカオオハシシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"limosa"
        sc:"melanuroides"
        ja:"オグロシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"lapponica"
        sc:"menzbieri"
        ja:"コシジロオオソリハシシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"lapponica"
        sc:"baueri"
        ja:"オオソリハシシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"phaeopus"
        sc:"variegatus"
        ja:"チュウシャクシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"arquata"
        sc:"orientalis"
        ja:"ダイシャクシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"totanus"
        sc:"ussuriensis"
        ja:"アカアシシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"interpres"
        sc:"interpres"
        ja:"キョウジョシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"canutus"
        sc:"rogersi"
        ja:"コオバシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"ptilocnemis"
        sc:"quarta"
        ja:"チシマシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alpina"
        sc:"sakhalina"
        ja:"ハマシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alpina"
        sc:"arcticola"
        ja:"キタアラスカハマシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"falcinellus"
        sc:"sibirica"
        ja:"キリアイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"benghalensis"
        sc:"benghalensis"
        ja:"タマシギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"suscitator"
        sc:"okinavensis"
        ja:"ミフウズラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"stolidus"
        sc:"pileatus"
        ja:"クロアジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"stolidus"
        sc:"pullus"
        ja:"リュウキュウクロアジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"minutus"
        sc:"marcusi"
        ja:"ヒメクロアジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cerulea"
        sc:"saxatilis"
        ja:"ハイイロアジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alba"
        sc:"candida"
        ja:"シロアジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"tridactyla"
        sc:"pollicaris"
        ja:"ミツユビカモメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"atricilla"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"canus"
        sc:"kamtschatschensis"
        ja:"カモメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"canus"
        sc:"heinei"
        ja:"ニシシベリアカモメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"canus"
        sc:"brachyrhynchus"
        ja:"コカモメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"hyperboreus"
        sc:"pallidissimus"
        ja:"シロカモメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"glaucoides"
        sc:"glaucoides"
        ja:"アイスランドカモメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"glaucoides"
        sc:"kumlieni"
        ja:"クムリーンアイスランドカモメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"argentatus"
        sc:"vegae"
        ja:"セグロカモメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"argentatus"
        sc:"smithsonianus"
        ja:"アメリカセグロカモメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cachinnans"
        sc:"mongolicus"
        ja:"キアシセグロカモメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"fuscus"
        sc:"heuglini"
        ja:"ニシセグロカモメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"fuscus"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"nilotica"
        sc:"nilotica"
        ja:"ハシブトアジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"bergii"
        sc:"cristata"
        ja:"オオアジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"bengalensis"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"albifrons"
        sc:"sinensis"
        ja:"コアジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"anaethetus"
        sc:"anaethetus"
        ja:"マミジロアジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"fuscata"
        sc:"nubilosa"
        ja:"セグロアジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"dougallii"
        sc:"bangsi"
        ja:"ベニアジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"hirundo"
        sc:"minussensis"
        ja:"アカアシアジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"hirundo"
        sc:"longipennis"
        ja:"アジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"hybrida"
        sc:"javanicus"
        ja:"クロハラアジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"niger"
        sc:"niger"
        ja:"ハシグロクロハラアジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"niger"
        sc:"surinamensis"
        ja:"アメリカハシグロクロハラアジサシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alle"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"lomvia"
        sc:"arra"
        ja:"ハシブトウミガラス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"aalge"
        sc:"inornata"
        ja:"ウミガラス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"torda"
        sc:"islandica"
        ja:"オオハシウミガラス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"columba"
        sc:"snowi"
        ja:"ウミバト"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"columba"
        sc:"kaiurka"
        ja:"アリューシャンウミバト"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"haliaetus"
        sc:"haliaetus"
        ja:"ミサゴ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"ptilorhynchus"
        sc:"orientalis"
        ja:"ハチクマ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"caeruleus"
        sc:"hypoleucus"
        ja:"カタグロトビ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"migrans"
        sc:"lineatus"
        ja:"トビ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"albicilla"
        sc:"albicilla"
        ja:"オジロワシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leucocephalus"
        sc:"washingtoniensis"
        ja:"ハクトウワシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cheela"
        sc:"perplexus"
        ja:"カンムリワシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"aeruginosus"
        sc:"aeruginosus"
        ja:"ヨーロッパチュウヒ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"spilonotus"
        sc:"spilonotus"
        ja:"チュウヒ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cyaneus"
        sc:"cyaneus"
        ja:"ハイイロチュウヒ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"gularis"
        sc:"gularis"
        ja:"ツミ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"gularis"
        sc:"iwasakii"
        ja:"リュウキュウツミ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"nisus"
        sc:"nisosimilis"
        ja:"ハイタカ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"gentilis"
        sc:"albidus"
        ja:"シロオオタカ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"gentilis"
        sc:"fujiyamae"
        ja:"オオタカ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"buteo"
        sc:"japonicus"
        ja:"ノスリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"buteo"
        sc:"toyoshimai"
        ja:"オガサワラノスリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"buteo"
        sc:"oshiroi"
        ja:"ダイトウノスリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"lagopus"
        sc:"menzbieri"
        ja:"ケアシノスリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"chrysaetos"
        sc:"japonica"
        ja:"イヌワシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"nipalensis"
        sc:"orientalis"
        ja:"クマタカ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"longimembris"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"lempiji"
        sc:"ussuriensis"
        ja:"サメイロオオコノハズク"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"lempiji"
        sc:"semitorques"
        ja:"オオコノハズク"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"lempiji"
        sc:"pryeri"
        ja:"リュウキュウオオコノハズク"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sunia"
        sc:"japonicus"
        ja:"コノハズク"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"elegans"
        sc:"interpositus"
        ja:"ダイトウコノハズク"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"elegans"
        sc:"elegans"
        ja:"リュウキュウコノハズク"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"bubo"
        sc:"kiautschensis"
        ja:"タイリクワシミミズク"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"bubo"
        sc:"borissowi"
        ja:"ワシミミズク"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"blakistoni"
        sc:"blakistoni"
        ja:"シマフクロウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"uralensis"
        sc:"japonica"
        ja:"エゾフクロウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"uralensis"
        sc:"hondoensis"
        ja:"フクロウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"uralensis"
        sc:"momiyamae"
        ja:"モミヤマフクロウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"uralensis"
        sc:"fuscescens"
        ja:"キュウシュウフクロウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"uralensis"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"funereus"
        sc:"magnus"
        ja:"キンメフクロウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"scutulata"
        sc:"macroptera"
        ja:"チョウセンアオバズク"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"scutulata"
        sc:"japonica"
        ja:"アオバズク"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"scutulata"
        sc:"totogo"
        ja:"リュウキュウアオバズク"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"otus"
        sc:"otus"
        ja:"トラフズク"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"flammeus"
        sc:"flammeus"
        ja:"コミミズク"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"epops"
        sc:"saturata"
        ja:"ヤツガシラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"coromanda"
        sc:"major"
        ja:"アカショウビン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"coromanda"
        sc:"bangsi"
        ja:"リュウキュウアカショウビン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"smyrnensis"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"chloris"
        sc:"collaris"
        ja:"ナンヨウショウビン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"atthis"
        sc:"bengalensis"
        ja:"カワセミ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"erithaca"
        sc:"erithaca"
        ja:"ミツユビカワセミ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"lugubris"
        sc:"pallida"
        ja:"エゾヤマセミ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"lugubris"
        sc:"lugubris"
        ja:"ヤマセミ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"orientalis"
        sc:"calonyx"
        ja:"ブッポウソウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"torquilla"
        sc:"chinensis"
        ja:"シベリアアリスイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"torquilla"
        sc:"japonica"
        ja:"アリスイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"hyperythrus"
        sc:"subrufinus"
        ja:"チャバラアカゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"kizuki"
        sc:"seebohmi"
        ja:"エゾコゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"kizuki"
        sc:"nippon"
        ja:"コゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"kizuki"
        sc:"matsudairai"
        ja:"ミヤケコゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"kizuki"
        sc:"shikokuensis"
        ja:"シコクコゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"kizuki"
        sc:"kotataki"
        ja:"ツシマコゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"kizuki"
        sc:"kizuki"
        ja:"キュウシュウコゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"kizuki"
        sc:"amamii"
        ja:"アマミコゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"kizuki"
        sc:"nigrescens"
        ja:"リュウキュウコゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"kizuki"
        sc:"orii"
        ja:"オリイコゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"kizuki"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"minor"
        sc:"amurensis"
        ja:"コアカゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leucotos"
        sc:"subcirris"
        ja:"エゾオオアカゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leucotos"
        sc:"stejnegeri"
        ja:"オオアカゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leucotos"
        sc:"namiyei"
        ja:"ナミエオオアカゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leucotos"
        sc:"owstoni"
        ja:"オーストンオオアカゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leucotos"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"major"
        sc:"brevirostris"
        ja:"ハシブトアカゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"major"
        sc:"japonicus"
        ja:"エゾアカゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"major"
        sc:"hondoensis"
        ja:"アカゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"tridactylus"
        sc:"inouyei"
        ja:"ミユビゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"javensis"
        sc:"richardsi"
        ja:"キタタキ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"martius"
        sc:"martius"
        ja:"クマゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"awokera"
        sc:"awokera"
        ja:"アオゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"awokera"
        sc:"horii"
        ja:"カゴシマアオゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"awokera"
        sc:"takatsukasae"
        ja:"タネアオゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"canus"
        sc:"jessoensis"
        ja:"ヤマゲラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"tinnunculus"
        sc:"interstinctus"
        ja:"チョウゲンボウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"columbarius"
        sc:"insignis"
        ja:"コチョウゲンボウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"columbarius"
        sc:"pacificus"
        ja:"ヒガシコチョウゲンボウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"subbuteo"
        sc:"subbuteo"
        ja:"チゴハヤブサ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cherrug"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"peregrinus"
        sc:"japonensis"
        ja:"ハヤブサ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"peregrinus"
        sc:"pealei"
        ja:"オオハヤブサ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"peregrinus"
        sc:"furuitii"
        ja:"シマハヤブサ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"peregrinus"
        sc:"anatum"
        ja:"アメリカハヤブサ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sordida"
        sc:"cucullata"
        ja:"ズグロヤイロチョウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leucorynchus"
        sc:"leucorynchus"
        ja:"モリツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"melaschistos"
        sc:"intermedia"
        ja:"アサクラサンショウクイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"divaricatus"
        sc:"divaricatus"
        ja:"サンショウクイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"divaricatus"
        sc:"tegimae"
        ja:"リュウキュウサンショウクイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"chinensis"
        sc:"diffusus"
        ja:"コウライウグイス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"macrocercus"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leucophaeus"
        sc:"leucogenis"
        ja:"ハイイロオウチュウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"hottentottus"
        sc:"brevirostris"
        ja:"カンムリオウチュウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"azurea"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"atrocaudata"
        sc:"atrocaudata"
        ja:"サンコウチョウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"atrocaudata"
        sc:"illex"
        ja:"リュウキュウサンコウチョウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"bucephalus"
        sc:"bucephalus"
        ja:"モズ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cristatus"
        sc:"lucionensis"
        ja:"シマアカモズ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cristatus"
        sc:"superciliosus"
        ja:"アカモズ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"collurio"
        sc:"pallidifrons"
        ja:"セアカモズ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"isabellinus"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"schach"
        sc:"schach"
        ja:"タカサゴモズ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"excubitor"
        sc:"mollis"
        ja:"シベリアオオモズ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"excubitor"
        sc:"bianchii"
        ja:"オオモズ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sphenocercus"
        sc:"sphenocercus"
        ja:"オオカラモズ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"glandarius"
        sc:"brandtii"
        ja:"ミヤマカケス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"glandarius"
        sc:"japonicus"
        ja:"カケス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"glandarius"
        sc:"tokugawae"
        ja:"サドカケス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"glandarius"
        sc:"orii"
        ja:"ヤクシマカケス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cyanus"
        sc:"japonica"
        ja:"オナガ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pica"
        sc:"serica"
        ja:"カササギ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"caryocatactes"
        sc:"macrorhynchos"
        ja:"ハシナガホシガラス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"caryocatactes"
        sc:"japonica"
        ja:"ホシガラス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"monedula"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"frugilegus"
        sc:"pastinator"
        ja:"ミヤマガラス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"corone"
        sc:"orientalis"
        ja:"ハシボソガラス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"macrorhynchos"
        sc:"mandshuricus"
        ja:"チョウセンハシブトガラス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"macrorhynchos"
        sc:"japonensis"
        ja:"ハシブトガラス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"macrorhynchos"
        sc:"connectens"
        ja:"リュウキュウハシブトガラス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"macrorhynchos"
        sc:"osai"
        ja:"オサハシブトガラス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"corax"
        sc:"kamtschaticus"
        ja:"ワタリガラス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"regulus"
        sc:"japonensis"
        ja:"キクイタダキ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pendulinus"
        sc:"consobrinus"
        ja:"ツリスガラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"palustris"
        sc:"hensoni"
        ja:"ハシブトガラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"montanus"
        sc:"sachalinensis"
        ja:"カラフトコガラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"montanus"
        sc:"restrictus"
        ja:"コガラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"varius"
        sc:"varius"
        ja:"ヤマガラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"varius"
        sc:"namiyei"
        ja:"ナミエヤマガラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"varius"
        sc:"owstoni"
        ja:"オーストンヤマガラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"varius"
        sc:"orii"
        ja:"ダイトウヤマガラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"varius"
        sc:"sunsunpi"
        ja:"タネヤマガラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"varius"
        sc:"yakushimensis"
        ja:"ヤクシマヤマガラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"varius"
        sc:"amamii"
        ja:"アマミヤマガラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"varius"
        sc:"olivaceus"
        ja:"オリイヤマガラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"ater"
        sc:"insularis"
        ja:"ヒガラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"minor"
        sc:"minor"
        ja:"シジュウカラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"minor"
        sc:"amamiensis"
        ja:"アマミシジュウカラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"minor"
        sc:"okinawae"
        ja:"オキナワシジュウカラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"minor"
        sc:"nigriloris"
        ja:"イシガキシジュウカラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"minor"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cyanus"
        sc:"tianschanicus"
        ja:"ルリガラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"biarmicus"
        sc:"russicus"
        ja:"ヒゲガラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"bimaculata"
        sc:"torquata"
        ja:"クビワコウテンシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"brachydactyla"
        sc:"longipennis"
        ja:"ヒメコウテンシ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cheleensis"
        sc:"cheleensis"
        ja:"コヒバリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"arvensis"
        sc:"pekinensis"
        ja:"オオヒバリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"arvensis"
        sc:"lonnbergi"
        ja:"カラフトチュウヒバリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"arvensis"
        sc:"japonica"
        ja:"ヒバリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alpestris"
        sc:"flava"
        ja:"ハマヒバリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"paludicola"
        sc:"chinensis"
        ja:"タイワンショウドウツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"riparia"
        sc:"ijimae"
        ja:"ショウドウツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"rustica"
        sc:"saturata"
        ja:"アカハラツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"rustica"
        sc:"gutturalis"
        ja:"ツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"tahitica"
        sc:"namiyei"
        ja:"リュウキュウツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"daurica"
        sc:"japonica"
        ja:"コシアカツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"urbicum"
        sc:"lagopodum"
        ja:"ニシイワツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"dasypus"
        sc:"dasypus"
        ja:"イワツバメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sinensis"
        sc:"sinensis"
        ja:"シロガシラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sinensis"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"amaurotis"
        sc:"amaurotis"
        ja:"ヒヨドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"amaurotis"
        sc:"squamiceps"
        ja:"オガサワラヒヨドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"amaurotis"
        sc:"magnirostris"
        ja:"ハシブトヒヨドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"amaurotis"
        sc:"borodinonis"
        ja:"ダイトウヒヨドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"amaurotis"
        sc:"ogawae"
        ja:"アマミヒヨドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"amaurotis"
        sc:"pryeri"
        ja:"リュウキュウヒヨドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"amaurotis"
        sc:"stejnegeri"
        ja:"イシガキヒヨドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"amaurotis"
        sc:"nagamichii"
        ja:"タイワンヒヨドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"diphone"
        sc:"sakhalinensis"
        ja:"カラフトウグイス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"diphone"
        sc:"borealis"
        ja:"チョウセンウグイス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"diphone"
        sc:"cantans"
        ja:"ウグイス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"diphone"
        sc:"diphone"
        ja:"ハシナガウグイス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"diphone"
        sc:"restricta"
        ja:"ダイトウウグイス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"diphone"
        sc:"riukiuensis"
        ja:"リュウキュウウグイス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"caudatus"
        sc:"japonicus"
        ja:"シマエナガ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"caudatus"
        sc:"magnus"
        ja:"チョウセンエナガ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"caudatus"
        sc:"trivirgatus"
        ja:"エナガ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"caudatus"
        sc:"kiusiuensis"
        ja:"キュウシュウエナガ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"trochilus"
        sc:"yakutensis"
        ja:"キタヤナギムシクイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"collybita"
        sc:"tristis"
        ja:"チフチャフ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"fuscatus"
        sc:"fuscatus"
        ja:"ムジセッカ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"affinis"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"borealis"
        sc:"borealis"
        ja:"コムシクイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"borealis"
        sc:"kennicotti"
        ja:"アメリカコムシクイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"curruca"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"familiare"
        sc:"familiare"
        ja:"メグロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"familiare"
        sc:"hahasima"
        ja:"ハハジマメグロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"japonicus"
        sc:"japonicus"
        ja:"メジロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"japonicus"
        sc:"stejnegeri"
        ja:"シチトウメジロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"japonicus"
        sc:"alani"
        ja:"イオウトウメジロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"japonicus"
        sc:"daitoensis"
        ja:"ダイトウメジロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"japonicus"
        sc:"insularis"
        ja:"シマメジロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"japonicus"
        sc:"loochooensis"
        ja:"リュウキュウメジロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"certhiola"
        sc:"rubescens"
        ja:"シベリアセンニュウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pryeri"
        sc:"pryeri"
        ja:"オオセッカ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"fasciolata"
        sc:"amnicola"
        ja:"エゾセンニュウ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"bistrigiceps"
        sc:"bistrigiceps"
        ja:"コヨシキリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"agricola"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"aedon"
        sc:"stegmanni"
        ja:"ハシブトオオヨシキリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"juncidis"
        sc:"brunniceps"
        ja:"セッカ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"garrulus"
        sc:"centralasiae"
        ja:"キレンジャク"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"europaea"
        sc:"asiatica"
        ja:"シロハラゴジュウカラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"europaea"
        sc:"amurensis"
        ja:"ゴジュウカラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"europaea"
        sc:"roseilia"
        ja:"キュウシュウゴジュウカラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"familiaris"
        sc:"daurica"
        ja:"キタキバシリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"familiaris"
        sc:"japonica"
        ja:"キバシリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"troglodytes"
        sc:"dauricus"
        ja:"チョウセンミソサザイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"troglodytes"
        sc:"fumigatus"
        ja:"ミソサザイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"troglodytes"
        sc:"mosukei"
        ja:"モスケミソサザイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"troglodytes"
        sc:"orii"
        ja:"ダイトウミソサザイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"troglodytes"
        sc:"ogawae"
        ja:"オガワミソサザイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"vulgaris"
        sc:"poltaratskyi"
        ja:"ホシムクドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pallasii"
        sc:"pallasii"
        ja:"カワガラス"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sibirica"
        sc:"davisoni"
        ja:"マミジロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"dauma"
        sc:"aurea"
        ja:"トラツグミ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"dauma"
        sc:"major"
        ja:"オオトラツグミ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"dauma"
        sc:"iriomotensis"
        ja:"コトラツグミ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"minimus"
        sc:"aliciae"
        ja:"ハイイロチャツグミ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"merula"
        sc:"mandarinus"
        ja:"クロウタドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"chrysolaus"
        sc:"orii"
        ja:"オオアカハラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"chrysolaus"
        sc:"chrysolaus"
        ja:"アカハラ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"ruficollis"
        sc:"atrogularis"
        ja:"ノドグロツグミ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"ruficollis"
        sc:"ruficollis"
        ja:"ノドアカツグミ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"naumanni"
        sc:"eunomus"
        ja:"ツグミ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"naumanni"
        sc:"naumanni"
        ja:"ハチジョウツグミ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"iliacus"
        sc:"iliacus"
        ja:"ワキアカツグミ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"viscivorus"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"rubecula"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"akahige"
        sc:"akahige"
        ja:"コマドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"akahige"
        sc:"tanensis"
        ja:"タネコマドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"komadori"
        sc:"komadori"
        ja:"アカヒゲ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"komadori"
        sc:"namiyei"
        ja:"ホントウアカヒゲ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"komadori"
        sc:"subrufus"
        ja:"ウスアカヒゲ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"svecica"
        sc:"svecica"
        ja:"オガワコマドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cyane"
        sc:"bochaiensis"
        ja:"コルリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cyanurus"
        sc:"cyanurus"
        ja:"ルリビタキ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"ochruros"
        sc:"rufiventris"
        ja:"クロジョウビタキ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"phoenicurus"
        sc:"phoenicurus"
        ja:"シロビタイジョウビタキ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"auroreus"
        sc:"auroreus"
        ja:"ジョウビタキ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"torquatus"
        sc:"stejnegeri"
        ja:"ノビタキ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"caprata"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"oenanthe"
        sc:"oenanthe"
        ja:"ハシグロヒタキ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"deserti"
        sc:"oreophila"
        ja:"サバクヒタキ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"solitarius"
        sc:"pandoo"
        ja:"アオハライソヒヨドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"solitarius"
        sc:"philippensis"
        ja:"イソヒヨドリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"striata"
        sc:"mongola"
        ja:"ムナフヒタキ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sibirica"
        sc:"sibirica"
        ja:"サメビタキ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"dauurica"
        sc:"dauurica"
        ja:"コサメビタキ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"hypoleuca"
        sc:"sibirica"
        ja:"マダラヒタキ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"narcissina"
        sc:"narcissina"
        ja:"キビタキ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"narcissina"
        sc:"owstoni"
        ja:"リュウキュウキビタキ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cyanomelana"
        sc:"cumatilis"
        ja:"チョウセンオオルリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cyanomelana"
        sc:"cyanomelana"
        ja:"オオルリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"thalassinus"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"vivida"
        sc:"vivida"
        ja:"チャバラオオルリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"collaris"
        sc:"erythropygia"
        ja:"イワヒバリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"montanella"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"domesticus"
        sc:"domesticus"
        ja:"イエスズメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"rutilans"
        sc:"rutilans"
        ja:"ニュウナイスズメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"montanus"
        sc:"saturatus"
        ja:"スズメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"flava"
        sc:"plexa"
        ja:"シベリアツメナガセキレイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"flava"
        sc:"leucocephala"
        ja:"カオジロツメナガセキレイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"flava"
        sc:"macronyx"
        ja:"キタツメナガセキレイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"flava"
        sc:"simillima"
        ja:"マミジロツメナガセキレイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"flava"
        sc:"taivana"
        ja:"ツメナガセキレイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"citreola"
        sc:"citreola"
        ja:"キガシラセキレイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cinerea"
        sc:"cinerea"
        ja:"キセキレイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alba"
        sc:"dukhunensis"
        ja:"ニシシベリアハクセキレイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alba"
        sc:"personata"
        ja:"メンガタハクセキレイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alba"
        sc:"alboides"
        ja:"ネパールハクセキレイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alba"
        sc:"baicalensis"
        ja:"シベリアハクセキレイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alba"
        sc:"ocularis"
        ja:"タイワンハクセキレイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alba"
        sc:"lugens"
        ja:"ハクセキレイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"alba"
        sc:"leucopsis"
        ja:"ホオジロハクセキレイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"richardi"
        sc:"richardi"
        ja:"マミジロタヒバリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pratensis"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"trivialis"
        sc:"trivialis"
        ja:"ヨーロッパビンズイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"hodgsoni"
        sc:"yunnanensis"
        ja:"カラフトビンズイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"hodgsoni"
        sc:"hodgsoni"
        ja:"ビンズイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"gustavi"
        sc:"gustavi"
        ja:"セジロタヒバリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"rubescens"
        sc:"japonicus"
        ja:"タヒバリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"coelebs"
        sc:"coelebs"
        ja:"ズアオアトリ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sinica"
        sc:"kawarahiba"
        ja:"オオカワラヒワ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sinica"
        sc:"minor"
        ja:"カワラヒワ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sinica"
        sc:"kittlitzi"
        ja:"オガサワラカワラヒワ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"flammea"
        sc:"flammea"
        ja:"ベニヒワ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"hornemanni"
        sc:"exilipes"
        ja:"コベニヒワ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"arctoa"
        sc:"brunneonucha"
        ja:"ハギマシコ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sibiricus"
        sc:"sanguinolentus"
        ja:"ベニマシコ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"erythrinus"
        sc:"grebnitskii"
        ja:"アカマシコ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"enucleator"
        sc:"kamtschatkensis"
        ja:"コバシギンザンマシコ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"enucleator"
        sc:"sakhalinensis"
        ja:"ギンザンマシコ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"curvirostra"
        sc:"japonica"
        ja:"イスカ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leucoptera"
        sc:"bifasciata"
        ja:"ナキイスカ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pyrrhula"
        sc:"cassinii"
        ja:"ベニバラウソ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pyrrhula"
        sc:"rosacea"
        ja:"アカウソ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pyrrhula"
        sc:"griseiventris"
        ja:"ウソ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"coccothraustes"
        sc:"coccothraustes"
        ja:"シベリアシメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"coccothraustes"
        sc:"japonicus"
        ja:"シメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"migratoria"
        sc:"migratoria"
        ja:"コイカル"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"personata"
        sc:"personata"
        ja:"イカル"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"lapponicus"
        sc:"coloratus"
        ja:"ツメナガホオジロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"nivalis"
        sc:"vlasowae"
        ja:"ユキホオジロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"nivalis"
        sc:"townsendi"
        ja:"オオユキホオジロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"coronata"
        sc:"coronata"
        ja:"キヅタアメリカムシクイ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pusilla"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"citrinella"
        sc:"erythrogenys"
        ja:"キアオジ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leucocephalos"
        sc:"leucocephalos"
        ja:"シラガホオジロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"cioides"
        sc:"ciopsis"
        ja:"ホオジロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"buchanani"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"fucata"
        sc:"fucata"
        ja:"ホオアカ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"rustica"
        sc:"latifascia"
        ja:"カシラダカ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"elegans"
        sc:"elegans"
        ja:"ミヤマホオジロ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"aureola"
        sc:"ornata"
        ja:"シマアオジ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"spodocephala"
        sc:"spodocephala"
        ja:"シベリアアオジ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"spodocephala"
        sc:"personata"
        ja:"アオジ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pallasi"
        sc:"polaris"
        ja:"シベリアジュリン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"pallasi"
        sc:"pallasi"
        ja:"オオシベリアジュリン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"yessoensis"
        sc:"yessoensis"
        ja:"コジュリン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"schoeniclus"
        sc:"pyrrhulina"
        ja:"オオジュリン"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"iliaca"
        sc:"unalaschcensis"
        ja:"ゴマフスズメ"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"melodia"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"leucophrys"
        sc:"gambelii"
        ja:"ミヤマシトド"
    }
    {
        "alien":false,
        rank:"subspecies"
        upper:"sandwichensis"
        sc:"sandwichensis"
        ja:"サバンナシトド"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"thoracicus"
        sc:"thoracicus"
        ja:"コジュケイ"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"thoracicus"
        sc:"sonorivox"
        ja:"テッケイ"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"soemmerringii"
        sc:"scintillans"
        ja:"ヤマドリ"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"soemmerringii"
        sc:"subrufus"
        ja:"ウスアカヤマドリ"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"soemmerringii"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"colchicus"
        sc:"karpowi"
        ja:"コウライキジ"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"colchicus"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"canadensis"
        sc:"moffitti"
        ja:"オオカナダガン"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"decaocto"
        sc:"decaocto"
        ja:"シラコバト"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"himantopus"
        sc:"mexicanus"
        ja:"クロエリセイタカシギ"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"krameri"
        sc:"manillensis"
        ja:"ワカケホンセイインコ"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"alexandri"
        sc:"fasciata"
        ja:"ダルマインコ"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"monachus"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"pica"
        sc:"serica"
        ja:"カササギ"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"japonicus"
        sc:"stejnegeri"
        ja:"シチトウメジロ"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"japonicus"
        sc:"alani"
        ja:"イオウトウメジロ"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"canorus"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"cineraceus"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"sannio"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"lutea"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"cristatellus"
        sc:"cristatellus"
        ja:"ハッカチョウ"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"tristis"
        sc:"tristis"
        ja:"インドハッカ"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"contra"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"intermedius"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"orix"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"melpoda"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"amandava"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"striata"
        sc:"ssp."
        ja:"亜種不明"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"punctulata"
        sc:"topela"
        ja:"シマキンパラ"
    }
    {
        "alien":true,
        rank:"subspecies"
        upper:"atricapilla"
        sc:"ssp."
        ja:"亜種不明"
    }
]

db.createCollection 'names'

rank_relationships =
    family:     "order"
    genus:      "family"
    species:    "genus"
    subspecies: "species"

for name in data_names
    if db.names.find(name).count() is 0

        if name.upper
            upper_rank = rank_relationships[name.rank]
            upper_id = db.names.find({
                rank: upper_rank
                sc: name.upper
            })[0]._id
            name.upper = upper_rank
            name.upper_id = upper_id
        db.names.insert name
